import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Eye, Flame, AlertTriangle, XCircle, CheckCircle, Clock, ShieldAlert, Dna, Zap, HelpCircle, AlertOctagon } from 'lucide-react';
export function NewProblemSection() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.01
  });
  const [ref2, inView2] = useInView({
    triggerOnce: true,
    threshold: 0.01
  });
  const [ref3, inView3] = useInView({
    triggerOnce: true,
    threshold: 0.01
  });
  const [ref4, inView4] = useInView({
    triggerOnce: true,
    threshold: 0.01
  });
  const [ref5, inView5] = useInView({
    triggerOnce: true,
    threshold: 0.01
  });
  const [ref6, inView6] = useInView({
    triggerOnce: true,
    threshold: 0.01
  });
  const [ref7, inView7] = useInView({
    triggerOnce: true,
    threshold: 0.01
  });
  const [ref8, inView8] = useInView({
    triggerOnce: true,
    threshold: 0.01
  });
  const [ref9, inView9] = useInView({
    triggerOnce: true,
    threshold: 0.01
  });
  const [ref10, inView10] = useInView({
    triggerOnce: true,
    threshold: 0.01
  });
  const [ref11, inView11] = useInView({
    triggerOnce: true,
    threshold: 0.01
  });
  const [ref12, inView12] = useInView({
    triggerOnce: true,
    threshold: 0.01
  });
  const [ref13, inView13] = useInView({
    triggerOnce: true,
    threshold: 0.01
  });
  const [ref14, inView14] = useInView({
    triggerOnce: true,
    threshold: 0.01
  });
  const [ref15, inView15] = useInView({
    triggerOnce: true,
    threshold: 0.01
  });
  return <section className="relative pt-8 sm:pt-12 pb-8 sm:pb-12 px-5 sm:px-6 bg-black" data-id="element-1075" data-mp="1v0xmqpe0ews5">
      {/* DRAMATIC VAULT TRANSFORMATION - Bold and unmistakable */}

      {/* Deep vault background - much darker than hero */}
      <div className="absolute inset-0 bg-gradient-to-b from-zinc-950 via-neutral-950 to-black" data-id="element-1076" data-mp="jl8xtsh73nop" />

      {/* Heavy concrete texture - very visible */}
      <div className="absolute inset-0 opacity-20" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='400' height='400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='4' /%3E%3C/filter%3E%3Crect width='400' height='400' filter='url(%23noise)' opacity='0.7'/%3E%3C/svg%3E")`,
      backgroundRepeat: 'repeat'
    }} data-id="element-1077" data-mp="2r8amzie2svcb" />

      {/* BOLD security grid - clearly visible */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: `
            linear-gradient(rgba(217, 119, 6, 0.6) 2px, transparent 2px),
            linear-gradient(90deg, rgba(217, 119, 6, 0.6) 2px, transparent 2px)
          `,
      backgroundSize: '80px 80px'
    }} data-id="element-1078" data-mp="23igcv8l55kvr" />

      {/* MASSIVE vault door frame - unmistakable borders */}
      <div className="absolute left-0 inset-y-0 w-8 bg-gradient-to-r from-stone-700 via-stone-800 to-transparent hidden lg:block" data-id="element-1079" data-mp="3nz2uvsquvh30" />
      <div className="absolute right-0 inset-y-0 w-8 bg-gradient-to-l from-stone-700 via-stone-800 to-transparent hidden lg:block" data-id="element-1080" data-mp="3vhaoj47ei540" />

      {/* TOP SECRET corner stamps - bold and visible */}
      <div className="absolute top-12 left-12 hidden lg:block" data-id="element-1081" data-mp="93spvpae00ll">
        <div className="relative w-32 h-32 border-4 border-amber-600/60 rotate-12 flex items-center justify-center" data-id="element-1082" data-mp="e1uhiylvp88o">
          <div className="absolute inset-0 bg-amber-600/10" data-id="element-1083" data-mp="3cjzqto1f3jqo" />
          <span className="text-amber-500 font-bold text-xs tracking-widest rotate-[-12deg]" data-id="element-1084" data-mp="3clklddnqf2oj">
            CLASSIFIED
          </span>
        </div>
      </div>
      <div className="absolute top-12 right-12 hidden lg:block" data-id="element-1085" data-mp="3mgmfyp0s0wyi">
        <div className="relative w-32 h-32 border-4 border-red-600/60 rotate-[-12deg] flex items-center justify-center" data-id="element-1086" data-mp="3rgh5op8tfghz">
          <div className="absolute inset-0 bg-red-600/10" data-id="element-1087" data-mp="11s85oe1cemxz" />
          <span className="text-red-500 font-bold text-xs tracking-widest rotate-12" data-id="element-1088" data-mp="11trmc5qwv00a">
            RESTRICTED
          </span>
        </div>
      </div>

      {/* Heavy vault door bolts on sides */}
      <div className="absolute left-2 sm:left-4 top-1/4 hidden lg:flex flex-col gap-16" data-id="element-1089" data-mp="14do5r5d91bij">
        {[...Array(3)].map((_, i) => <div key={i} className="w-6 h-6 sm:w-8 sm:h-8 rounded-full bg-gradient-to-br from-stone-600 to-stone-800 border-2 border-amber-700/40 shadow-lg" data-id="element-1090" data-mp="1eak96woaj7g8" data-mpi={i}>
            <div className="w-full h-full rounded-full bg-gradient-to-br from-stone-700 to-stone-900 m-0.5" data-id="element-1091" data-mp="1na78ncxgm36n" />
          </div>)}
      </div>
      <div className="absolute right-2 sm:right-4 top-1/4 hidden lg:flex flex-col gap-16" data-id="element-1092" data-mp="1j8lyhzcb8305">
        {[...Array(3)].map((_, i) => <div key={i} className="w-6 h-6 sm:w-8 sm:h-8 rounded-full bg-gradient-to-br from-stone-600 to-stone-800 border-2 border-amber-700/40 shadow-lg" data-id="element-1093" data-mp="1s1fiub6m5skv" data-mpi={i}>
            <div className="w-full h-full rounded-full bg-gradient-to-br from-stone-700 to-stone-900 m-0.5" data-id="element-1094" data-mp="26wbwj3x6z85c" />
          </div>)}
      </div>

      {/* STRONG vignette - vault entrance */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_transparent_0%,_rgba(0,0,0,0.4)_70%,_rgba(0,0,0,0.8)_100%)] pointer-events-none" data-id="element-1095" data-mp="2ljkf4pstyfrc" />

      {/* Dark top shadow - descending into vault */}
      <div className="absolute top-0 inset-x-0 h-32 sm:h-48 bg-gradient-to-b from-black via-black/60 to-transparent pointer-events-none" data-id="element-1096" data-mp="2gmbyitnbyjs7" />

      <motion.div ref={ref} initial={{
      opacity: 0,
      y: 20
    }} animate={inView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.4
    }} className="relative z-10 max-w-4xl mx-auto" data-id="element-1097" data-mp="21wcxmj4e4u91">
        {/* Header */}
        <div className="flex items-center justify-center gap-4 mb-6 sm:mb-8" data-id="element-1098" data-mp="1izl8vu62xmxl">
          <div className="w-16 sm:w-24 h-px bg-gradient-to-r from-transparent via-amber-600/50 to-transparent" data-id="element-1099" data-mp="1ny69hup8u8mk" />
          <Eye className="w-6 h-6 sm:w-8 sm:h-8 text-amber-500" data-id="element-1100" data-mp="14t9svzmenyhl" />
          <div className="w-16 sm:w-24 h-px bg-gradient-to-r from-transparent via-amber-600/50 to-transparent" data-id="element-1101" data-mp="102bb0vlrqsc8" />
        </div>

        <h2 className="text-3xl sm:text-5xl md:text-7xl lg:text-8xl font-serif mb-8 sm:mb-12 text-center text-stone-100 leading-tight" style={{
        fontFamily: 'Cinzel, serif',
        textShadow: '0 0 40px rgba(217, 119, 6, 0.3)'
      }} data-id="element-1102" data-mp="v2f70wd2n0wo">
          The Future Is Becoming{' '}
          <span className="inline-block bg-gradient-to-r from-stone-100 via-orange-400 to-red-500 bg-clip-text text-transparent font-bold" style={{
          textShadow: '0 0 30px rgba(249, 115, 22, 0.5)'
        }} data-id="element-1103" data-mp="1iu440q0u8djy">
            Increasingly
          </span>{' '}
          <span className="inline-block text-red-500 font-extrabold" style={{
          textShadow: '0 0 60px rgba(220, 38, 38, 0.8), 0 0 100px rgba(220, 38, 38, 0.4)'
        }} data-id="element-1104" data-mp="2g477nxah40x">
            Fake
          </span>
        </h2>

        <div className="space-y-6 sm:space-y-8 text-lg md:text-xl leading-relaxed text-stone-300" data-id="element-1105" data-mp="2e2o93mbu7gga">
          <p className="text-stone-100 text-center text-lg sm:text-xl" data-id="element-1106" data-mp="2j07lshsvzl64">
            And Your Biology Is Paying The Price
          </p>

          <p className="text-xl md:text-2xl font-bold text-stone-100" data-id="element-1107" data-mp="2ntivcqp32g1q">
            Here's what's happening right now while you read this:
          </p>

          {/* AI Hallucinations */}
          <div className="space-y-3 sm:space-y-4" data-id="element-1108" data-mp="2wuh1pfmzuznh">
            <p className="text-stone-100 font-semibold text-base sm:text-lg" data-id="element-1109" data-mp="31r7h00qz5r7u">
              AI chatbots are confidently hallucinating garbage health advice
              that is being spread and used as material by... More AI chatbots.
            </p>
            <p className="pl-4 sm:pl-6 border-l-2 border-amber-600/30 text-base sm:text-lg" data-id="element-1110" data-mp="17fk85ab8zq8g">
              One wrong Reddit post gets cited by a blogger, quoted by a
              YouTuber, summarized by ChatGPT, and trusted by thousands who
              think they're getting the truth.
            </p>
          </div>

          {/* Influencers */}
          <div className="space-y-3 sm:space-y-4" data-id="element-1111" data-mp="3nyuppuxouw8p">
            <p className="text-stone-100 font-semibold text-base sm:text-lg" data-id="element-1112" data-mp="3o1qp7np6psz9">
              Influencers are optimizing for views and engagement, not accuracy
              and outcomes.
            </p>
            <p className="pl-4 sm:pl-6 border-l-2 border-amber-600/30 text-base sm:text-lg" data-id="element-1113" data-mp="2vd1tk46wefuw">
              They're teaching peptide "stacks" they don't understand because
              the algorithm rewards confident simplicity over nuanced precision.
            </p>
          </div>

          {/* Doctors */}
          <div className="space-y-3 sm:space-y-4" data-id="element-1114" data-mp="kj5q3786ghie">
            <p className="text-stone-100 font-semibold text-base sm:text-lg" data-id="element-1115" data-mp="khma7hqfo8h5">
              Even qualified doctors are operating with fragments of knowledge,
              regurgitating what they heard from someone who heard it from
              someone else.
            </p>
            <p className="pl-4 sm:pl-6 border-l-2 border-amber-600/30 italic text-stone-400 text-base sm:text-lg" data-id="element-1116" data-mp="s2yh0g2f92ky">
              A broken telephone game with your biology as the stakes.
            </p>
          </div>

          {/* Getting worse */}
          <div className="space-y-3 sm:space-y-4 mt-8 sm:mt-12" data-id="element-1117" data-mp="i6li93s0ryjc">
            <p className="text-xl md:text-2xl font-bold text-stone-100" data-id="element-1118" data-mp="15veel1ck08eh">
              But it's getting WORSE.
            </p>
            <p className="text-2xl md:text-3xl font-bold text-amber-500" style={{
            textShadow: '0 0 30px rgba(217, 119, 6, 0.3)'
          }} data-id="element-1119" data-mp="1avail0l93zu1">
              Way worse.
            </p>
          </div>

          <p className="text-lg md:text-xl text-stone-100" data-id="element-1120" data-mp="1orwdc2ptl8k8">
            And if you don't have a trusted source of REAL intelligence...
          </p>

          <p className="text-2xl md:text-3xl font-bold text-center text-amber-500" style={{
          textShadow: '0 0 30px rgba(217, 119, 6, 0.4)'
        }} data-id="element-1121" data-mp="1tlilbhl1go9p">
            You're gonna get buried.
          </p>

          {/* Divider */}
          <div className="flex items-center justify-center gap-4 py-8 sm:py-12 mt-10 sm:mt-16" data-id="element-1122" data-mp="34m8dbhz0yg8s">
            <div className="w-16 sm:w-32 h-px bg-gradient-to-r from-transparent via-amber-600/50 to-amber-600/50" data-id="element-1123" data-mp="39he0ek45y0yg" />
            <div className="w-2 h-2 bg-amber-600 rotate-45" data-id="element-1124" data-mp="2vpzbxxrhl7k0" />
            <div className="w-16 sm:w-32 h-px bg-gradient-to-l from-transparent via-amber-600/50 to-amber-600/50" data-id="element-1125" data-mp="30jbym2clv4a4" />
          </div>

          {/* Section 2: Butterfly Effect */}
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-serif text-center text-stone-100 mt-10 sm:mt-16 mb-8 sm:mb-12" style={{
          fontFamily: 'Cinzel, serif',
          textShadow: '0 0 30px rgba(217, 119, 6, 0.2)'
        }} data-id="element-1126" data-mp="2qrxybscty0fx">
            The Butterfly Effect of{' '}
            <span className="text-amber-500" style={{
            textShadow: '0 0 40px rgba(217, 119, 6, 0.5)'
          }} data-id="element-1127" data-mp="1y6j0y8nxpjk4">
              AI Hallucinations
            </span>
          </h2>

          {/* Turing quote */}
          <div className="bg-stone-950/50 border-l-4 border-amber-600 p-6 sm:p-8 my-6 sm:my-8" data-id="element-1128" data-mp="226t47dkcdvva">
            <p className="text-sm sm:text-base text-stone-400 mb-2" data-id="element-1129" data-mp="2h43falt2ozqh">
              In 1950, Alan Turing (one of the "godfathers" of modern AI and
              computing) noted:
            </p>
            <p className="text-lg md:text-xl text-stone-100 italic leading-relaxed" data-id="element-1130" data-mp="2pxoug695gj0f">
              "The displacement of a single electron by a billionth of a
              centimetre at one moment might make the difference between a man
              being killed by an avalanche a year later, or escaping."
            </p>
          </div>

          {/* Alan Turing Portrait */}
          <div className="flex justify-center my-8" data-id="element-1131" data-mp="1sjdnn5p06mx0">
            <div className="relative inline-block" data-id="element-1132" data-mp="1skyiyxj569vx">
              {/* Ornate oval frame */}
              <div className="relative w-48 h-64 md:w-56 md:h-72" data-id="element-1133" data-mp="1wl8knxzwie4z">
                {/* Outer glow */}
                <div className="absolute inset-0 rounded-[50%] bg-gradient-to-b from-amber-600/20 to-amber-900/20 blur-xl" data-id="element-1134" data-mp="21ih74as314c1" />

                {/* Frame border */}
                <div className="absolute inset-0 rounded-[50%] border-4 border-amber-600/40 shadow-[0_0_30px_rgba(217,119,6,0.3)]" data-id="element-1135" data-mp="2baeibhj3bwar" />
                <div className="absolute inset-1 rounded-[50%] border-2 border-amber-500/20" data-id="element-1136" data-mp="2g751weu3ta0x" />

                {/* Image container */}
                <div className="absolute inset-3 rounded-[50%] overflow-hidden bg-stone-900" data-id="element-1137" data-mp="2p9e6ko2oy96e">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nuhSeJBYyic5QEPhD1HjfW/Alan_turing_header.jpg" alt="Alan Turing" className="w-full h-full object-cover grayscale" data-id="element-1138" data-mp="pwa4moaq1q0z" />
                </div>
              </div>

              {/* Name plate */}
              <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 bg-stone-950 border border-amber-600/50 px-4 py-1 whitespace-nowrap" data-id="element-1139" data-mp="ik2qr1cewkxk">
                <p className="text-sm text-amber-500 font-semibold tracking-wide" data-id="element-1140" data-mp="djoipjat9azj">
                  Alan Turing
                </p>
              </div>
            </div>
          </div>

          <p className="text-xl font-bold text-stone-100" data-id="element-1141" data-mp="169x21eh321fp">
            He was describing chaos theory, and what would later come to be
            known as the "butterfly effect."
          </p>

          <p className="text-lg md:text-xl text-stone-100" data-id="element-1142" data-mp="wapho7bxl6j3">
            Small changes.{' '}
            <span className="text-amber-500 font-bold" data-id="element-1143" data-mp="sae0j4is1ocd">
              Massive consequences.
            </span>
          </p>

          {/* Cascade effect */}
          <div className="space-y-4 pl-6 border-l-2 border-amber-600/30" data-id="element-1144" data-mp="3d0mqofeml0a4">
            <p data-id="element-1145" data-mp="14sgdqqk20ji2">A slight error in a large language model's output...</p>
            <p data-id="element-1146" data-mp="14r59kpmp59qf">Gets repeated by thousands of people who trust it...</p>
            <p data-id="element-1147" data-mp="19k81yufqmd51">
              Gets scraped by OTHER AI tools that use it to generate MORE
              content...
            </p>
          </div>

          <p className="text-xl md:text-2xl font-bold text-stone-100" data-id="element-1148" data-mp="usfpqrb8pf7j">
            And suddenly, the entire internet is littered with confidently
            incorrect information that FEELS true... but isn't.
          </p>

          {/* Transition to next section */}
          <div className="relative bg-gradient-to-br from-amber-950/30 to-black border-2 border-amber-600 p-6 sm:p-8 md:p-10 mt-12 sm:mt-16" data-id="element-1149" data-mp="1shit1rr7u09e">
            <div className="absolute top-0 left-0 w-6 sm:w-8 h-6 sm:h-8 border-l-2 border-t-2 border-amber-600" data-id="element-1150" data-mp="1ijl4f35g21g9" />
            <div className="absolute top-0 right-0 w-6 sm:w-8 h-6 sm:h-8 border-r-2 border-t-2 border-amber-600" data-id="element-1151" data-mp="32kz8rbnbjha" />
            <div className="absolute bottom-0 left-0 w-6 sm:w-8 h-6 sm:h-8 border-l-2 border-b-2 border-amber-600" data-id="element-1152" data-mp="75r2dq3goujj" />
            <div className="absolute bottom-0 right-0 w-6 sm:w-8 h-6 sm:h-8 border-r-2 border-b-2 border-amber-600" data-id="element-1153" data-mp="3vozw3ap8qnyh" />

            <p className="text-xl sm:text-2xl md:text-3xl text-center text-amber-500 font-bold leading-relaxed" style={{
            textShadow: '0 0 30px rgba(217, 119, 6, 0.5)'
          }} data-id="element-1154" data-mp="3qtkkkpeph458">
              The signal-to-noise ratio in biological optimization has reached a
              critical low.
            </p>
          </div>
        </div>
      </motion.div>

      {/* NEW SECTION: AI YouTube Channel Example */}
      <motion.div ref={ref9} initial={{
      opacity: 1,
      y: 0
    }} animate={inView9 ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.4
    }} className="relative z-10 max-w-4xl mx-auto mt-12 sm:mt-20" data-id="element-1155" data-mp="3mqo8zinl28as">
        {/* Divider */}
        <div className="flex items-center justify-center gap-4 mb-8 sm:mb-12" data-id="element-1156" data-mp="3exuuqtc6256u">
          <div className="w-16 sm:w-32 h-px bg-gradient-to-r from-transparent via-amber-600/50 to-amber-600/50" data-id="element-1157" data-mp="3iz6ewjc9ty7n" />
          <div className="w-2 h-2 bg-amber-600 rotate-45" data-id="element-1158" data-mp="3ns998tovhbow" />
          <div className="w-16 sm:w-32 h-px bg-gradient-to-l from-transparent via-amber-600/50 to-amber-600/50" data-id="element-1159" data-mp="3sprm2v60gb26" />
        </div>

        {/* Headline */}
        <h3 className="text-2xl sm:text-3xl md:text-4xl font-serif font-bold text-center text-stone-100 mb-8 sm:mb-12" style={{
        fontFamily: 'Cinzel, serif',
        textShadow: '0 0 20px rgba(217, 119, 6, 0.2)'
      }} data-id="element-1160" data-mp="2w1lblrmeqofz">
          When I Saw the Image Below, I Realized{' '}
          <span className="text-red-500" data-id="element-1161" data-mp="39x6zfvgwn26t">Humanity Was In Trouble</span>
        </h3>

        {/* Image */}
        <div className="relative mb-12" data-id="element-1162" data-mp="p9c3ysbtr0g3">
          <div className="absolute -inset-1 bg-gradient-to-r from-amber-600/20 to-red-600/20 rounded-lg blur" data-id="element-1163" data-mp="p89hqxpg5m6i" />
          <div className="relative bg-stone-950 p-2 rounded-lg border border-amber-600/30" data-id="element-1164" data-mp="29qtpqak93dcb">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dJZbq3Yek5VH6X3WfXdXqi/b4e72e43-3622-4e89-a982-bb2047fc45f9-tinyfied.png" alt="AI-generated YouTube channel uploading daily" className="w-full rounded" data-id="element-1165" data-mp="24tl41zzw8r6b" />
          </div>
        </div>

        {/* Body copy */}
        <div className="space-y-6 text-lg md:text-xl leading-relaxed text-stone-300" data-id="element-1166" data-mp="1qyslstsmcww1">
          <p className="text-stone-100 font-semibold" data-id="element-1167" data-mp="1m0h9mceuqaan">
            I came across this entire YouTube channel that was being run 100% by
            AI.
          </p>

          <div className="bg-stone-950/50 border-l-4 border-red-600/50 p-4 sm:p-6 space-y-3" data-id="element-1168" data-mp="1c4ny8wcvcmug">
            <p className="text-stone-100" data-id="element-1169" data-mp="3bfnq1wgcjar5">
              The script?{' '}
              <span className="font-bold text-red-400" data-id="element-1170" data-mp="36hvp6cxq4eat">AI-generated.</span>
            </p>
            <p className="text-stone-100" data-id="element-1171" data-mp="2fc9rcg3z8u5f">
              The voiceover?{' '}
              <span className="font-bold text-red-400" data-id="element-1172" data-mp="2fecr3ruxm1nc">AI-generated.</span>
            </p>
            <p className="text-stone-100" data-id="element-1173" data-mp="2kal16qu9v4nn">
              The visuals?{' '}
              <span className="font-bold text-red-400" data-id="element-1174" data-mp="26j6lasvnvjkt">AI-generated.</span>
            </p>
            <p className="text-stone-100" data-id="element-1175" data-mp="2aki1k7snasgc">
              The thumbnails?{' '}
              <span className="font-bold text-red-400" data-id="element-1176" data-mp="1wl8vi0y5leq3">AI-generated.</span>
            </p>
            <p className="text-stone-100" data-id="element-1177" data-mp="21klkoschyxvu">
              The music?{' '}
              <span className="font-bold text-red-400" data-id="element-1178" data-mp="21iiil9y2lear">AI-generated.</span>
            </p>
          </div>

          <p className="text-xl md:text-2xl font-bold text-stone-100" data-id="element-1179" data-mp="1nngd2nx4xqyh">
            It was churning out{' '}
            <span className="text-red-500" style={{
            textShadow: '0 0 20px rgba(239, 68, 68, 0.4)'
          }} data-id="element-1180" data-mp="3hz4vj02ksbnm">
              VIRAL
            </span>{' '}
            content. <span className="text-amber-500" data-id="element-1181" data-mp="1aclep55mt8oa">Every. Single. Day.</span>
          </p>

          <div className="pl-4 sm:pl-6 border-l-2 border-amber-600/30 space-y-3" data-id="element-1182" data-mp="16cb6rmya486s">
            <p data-id="element-1183" data-mp="1k368mfad1p0v">Long videos.</p>
            <p data-id="element-1184" data-mp="1k3g2idyj0gbu">Thousands of views.</p>
            <p data-id="element-1185" data-mp="1k4hcef3t2wrz">Climbing the algorithm.</p>
          </div>

          <p className="text-2xl md:text-3xl font-bold text-center text-red-500 mt-6 sm:mt-8" data-id="element-1186" data-mp="1fc7n91aim0qr">
            And almost{' '}
            <span style={{
            textShadow: '0 0 30px rgba(239, 68, 68, 0.5)'
          }} data-id="element-1187" data-mp="1tzsr4xf7s3zq">
              NOBODY
            </span>{' '}
            in the comments realized it was fake.
          </p>

          {/* NEW SECTION: FDR Hallucination */}
          <div className="space-y-8 sm:space-y-12 mt-12 sm:mt-16" data-id="element-1188" data-mp="1y48uos1cuzbs">
            <p className="text-2xl md:text-3xl font-bold text-stone-100" data-id="element-1189" data-mp="8nhm1p10qs0l">
              But here's where it gets{' '}
              <span className="text-red-500" style={{
              textShadow: '0 0 30px rgba(239, 68, 68, 0.5)'
            }} data-id="element-1190" data-mp="3pzjqhhibb1k">
                insidious
              </span>
              ...
            </p>

            <p className="text-lg sm:text-xl text-stone-100 font-semibold" data-id="element-1191" data-mp="3gxx68wn891ne">
              In one of the videos, the AI hallucinated a "fact."
            </p>

            <p className="text-lg sm:text-xl text-stone-100 border-l-4 border-red-600 pl-4 sm:pl-6 py-2 bg-red-950/10" data-id="element-1192" data-mp="3cxd8bqutxu07">
              It confidently stated that{' '}
              <span className="font-bold text-red-400" data-id="element-1193" data-mp="2k8xw1c331psk">
                Franklin Delano Roosevelt
              </span>{' '}
              is the president on Mount Rushmore.
            </p>

            {/* FDR Image */}
            <div className="relative my-8" data-id="element-1194" data-mp="2t715vb4pgy4j">
              <div className="absolute -inset-1 bg-gradient-to-r from-red-600/20 to-amber-600/20 rounded-lg blur" data-id="element-1195" data-mp="dhg92skk6f46" />
              <div className="relative bg-stone-950 p-2 rounded-lg border border-red-600/30" data-id="element-1196" data-mp="8ivaexkyg3hu">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/aFRrizYEorcBCvdGpoiDKS/FDR-Visual-tinyfied.png" alt="AI-generated FDR visual from video" className="w-full rounded" data-id="element-1197" data-mp="gyuk9q6fkgjo" />
              </div>
            </div>

            <p className="text-2xl md:text-3xl font-bold text-stone-100" data-id="element-1198" data-mp="bzrdo1asy29l">
              Except... FDR is{' '}
              <span className="text-red-500 uppercase" style={{
              textShadow: '0 0 30px rgba(239, 68, 68, 0.5)'
            }} data-id="element-1199" data-mp="zplokdbk9gr7">
                NOT
              </span>{' '}
              the Roosevelt on Mount Rushmore.
            </p>

            <p className="text-lg sm:text-xl text-stone-100 font-semibold pl-4 sm:pl-6 border-l-2 border-amber-600/30" data-id="element-1200" data-mp="uydinr9fwdis">
              In reality that's{' '}
              <span className="text-amber-500 font-bold" data-id="element-1201" data-mp="1imwmnulgi452">
                Theodore Roosevelt
              </span>
              .
            </p>

            <p className="text-xl sm:text-2xl font-bold text-stone-100" data-id="element-1202" data-mp="1xadjpcsv8p4d">
              But the AI didn't stop there.
            </p>

            <p className="text-lg sm:text-xl text-red-400 font-semibold" data-id="element-1203" data-mp="1sd50r9zw8h22">
              It then GENERATED an image of FDR... ON Mount Rushmore.
            </p>

            {/* FDR on Mount Rushmore Image */}
            <div className="relative my-8" data-id="element-1204" data-mp="1jdqc8g3aegk7">
              <div className="absolute -inset-1 bg-gradient-to-r from-red-600/30 to-red-600/30 rounded-lg blur-lg" data-id="element-1205" data-mp="1ecu4tsjq8ca1" />
              <div className="relative bg-stone-950 p-2 rounded-lg border-2 border-red-600/50" data-id="element-1206" data-mp="19l2dhfsqy2iu">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fRUyWfrFdHjTMpduYvvgb3/FDR-On-Mt-Rushmore-tinyfied.png" alt="AI-generated image of FDR on Mount Rushmore" className="w-full rounded" data-id="element-1207" data-mp="14nj0ej7sbvsh" />
              </div>
            </div>

            <p className="text-2xl md:text-3xl font-bold text-center text-red-500" style={{
            textShadow: '0 0 40px rgba(239, 68, 68, 0.6)'
          }} data-id="element-1208" data-mp="qnhweuw8488s">
              Reinforcing its OWN hallucination.
            </p>

            <p className="text-lg sm:text-xl text-stone-100 font-semibold mt-6 sm:mt-8" data-id="element-1209" data-mp="3bc2sfhapkqll">
              And the comments?
            </p>

            <p className="text-lg sm:text-xl text-stone-100 font-semibold" data-id="element-1210" data-mp="3g808rnlz1wyd">
              Almost nobody caught it.
            </p>

            <p className="text-3xl md:text-4xl font-bold text-center text-stone-100 mt-6 sm:mt-8" style={{
            textShadow: '0 0 30px rgba(217, 119, 6, 0.3)'
          }} data-id="element-1211" data-mp="2nkxfpb02eefi">
              People just... believed it.
            </p>
          </div>

          {/* Divider */}
          <div className="flex items-center justify-center gap-4 py-8 sm:py-12 my-8 sm:my-12" data-id="element-1212" data-mp="1zv340wrhevwu">
            <div className="w-16 sm:w-32 h-px bg-gradient-to-r from-transparent via-red-600/50 to-red-600/50" data-id="element-1213" data-mp="24twa444fvkmz" />
            <div className="w-2 h-2 bg-red-600 rotate-45" data-id="element-1214" data-mp="bcqi0roim6ea" />
            <div className="w-16 sm:w-32 h-px bg-gradient-to-l from-transparent via-red-600/50 to-red-600/50" data-id="element-1215" data-mp="6dnni165vikk" />
          </div>

          {/* Health Connection */}
          <h3 className="text-2xl sm:text-3xl md:text-4xl font-serif font-bold text-center text-stone-100 mb-8 sm:mb-12" style={{
          fontFamily: 'Cinzel, serif',
          textShadow: '0 0 20px rgba(217, 119, 6, 0.2)'
        }} data-id="element-1216" data-mp="k6n3035y1cs4">
            But It's Not Just History. It's Your{' '}
            <span className="text-red-500" style={{
            textShadow: '0 0 30px rgba(239, 68, 68, 0.5)'
          }} data-id="element-1217" data-mp="133wk3dnsqe67">
              HEALTH
            </span>
            .
          </h3>

          <div className="space-y-6 text-lg md:text-xl leading-relaxed text-stone-300" data-id="element-1218" data-mp="34v1dof9ahot6">
            <p className="text-xl md:text-2xl text-stone-100 font-semibold" data-id="element-1219" data-mp="30uquu20ef3ww">
              Now imagine that same process happening with PEPTIDES.
            </p>

            <div className="pl-4 sm:pl-6 border-l-2 border-red-600/50 space-y-4 text-base sm:text-lg" data-id="element-1220" data-mp="2urchpzg1ogzt">
              <p className="text-stone-100" data-id="element-1221" data-mp="2h07q9kmtyv0k">
                With molecules you're putting into{' '}
                <span className="font-bold text-red-400" data-id="element-1222" data-mp="2lxpoafzb7pts">YOUR</span> body.
              </p>
              <p className="text-stone-100" data-id="element-1223" data-mp="270qlr6jben66">
                With advice that affects{' '}
                <span className="font-bold text-red-400" data-id="element-1224" data-mp="2c035hiew3e4j">YOUR</span> brain,{' '}
                <span className="font-bold text-red-400" data-id="element-1225" data-mp="1y0k0gyhdkiwg">YOUR</span> organs,{' '}
                <span className="font-bold text-red-400" data-id="element-1226" data-mp="1y2n1edk2fwfy">YOUR</span> wellbeing.
              </p>
            </div>

            <p className="text-xl md:text-2xl font-bold text-stone-100" data-id="element-1227" data-mp="231hrm0kd4na3">
              Because it's already happening.
            </p>

            <p className="text-2xl md:text-3xl font-bold text-center text-amber-500 mt-6 sm:mt-8" style={{
            textShadow: '0 0 30px rgba(217, 119, 6, 0.4)'
          }} data-id="element-1228" data-mp="18jwtz70zkmi">
              Let me show you.
            </p>
          </div>

          {/* Divider */}

          {/* Section 1: Elon/LeBron */}
          <div className="space-y-8" data-id="element-1229" data-mp="3m05xyxl2vdu9"></div>

          {/* Divider */}
          <div className="flex items-center justify-center gap-4 py-8 sm:py-12 mt-8 sm:mt-16" data-id="element-1230" data-mp="3h0t1rm8bguf0">
            <div className="w-24 h-px bg-gradient-to-r from-transparent via-amber-600/50 to-amber-600/50" data-id="element-1231" data-mp="ih2xj62jwxym" />
            <div className="w-2 h-2 bg-amber-600 rotate-45" data-id="element-1232" data-mp="djb5mc1wpbuf" />
            <div className="w-24 h-px bg-gradient-to-l from-transparent via-amber-600/50 to-amber-600/50" data-id="element-1233" data-mp="8r1747mq73gj" />
          </div>

          {/* Section 2: BPC-157 vs Vesugen */}
          <div className="space-y-8" data-id="element-1234" data-mp="1183wvv7l2vip">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-center text-stone-100 leading-tight" style={{
            fontFamily: 'Cinzel, serif'
          }} data-id="element-1235" data-mp="1195eyjn0oi9x">
              <span className="text-yellow-400" style={{
              textShadow: '0 0 30px rgba(234, 179, 8, 0.4)'
            }} data-id="element-1236" data-mp="13ucvj08ap3ab">
                AI Does Not Know What It's Saying
              </span>
              {' - '}
              <span className="text-yellow-300" data-id="element-1237" data-mp="1iqkfq0jpe4pl">Example #1</span>
            </h3>

            <div className="text-lg md:text-xl text-stone-300 space-y-6 leading-relaxed" data-id="element-1238" data-mp="1mqcs6oc7wv08">
              <p data-id="element-1239" data-mp="1rppen7z6g02a">
                ChatGPT was asked to list the best peptides for vascular health.
              </p>

              <p data-id="element-1240" data-mp="1wiii7siwt2cs">
                It confidently listed{' '}
                <span className="text-stone-100 font-bold" data-id="element-1241" data-mp="21g0spnckrpmw">
                  BPC-157, TB-500, and others.
                </span>
              </p>

              <p className="text-lg sm:text-xl text-stone-100 font-bold border-l-4 border-red-600 pl-4 sm:pl-6 py-2 bg-red-950/10" data-id="element-1242" data-mp="26gyahytoahnv">
                But somehow it SKIPPED what should have been the absolute top
                recommendation – <span className="text-red-400" data-id="element-1243" data-mp="2vtrtgw6g3ffs">Vesugen</span>.
              </p>

              {/* Image */}
              <div className="relative my-8 max-w-2xl mx-auto" data-id="element-1244" data-mp="35q383stichde">
                <div className="absolute -inset-1 bg-gradient-to-r from-red-600/20 to-amber-600/20 rounded-lg blur opacity-75" data-id="element-1245" data-mp="35pl58dccb4wi" />
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9d6nVvQcppnhCKKcbixi1c/ChatGPTSkippedVesugen-tinyfied.png" alt="ChatGPT skipping Vesugen" className="relative rounded-lg border border-stone-800 w-full" data-id="element-1246" data-mp="30p77pp8d7dcq" />
              </div>

              <p data-id="element-1247" data-mp="2i0seqwehlp9a">
                And when pressed, it claimed Vesugen didn't have enough
                scientific backing.
              </p>

              <p className="italic text-stone-400" data-id="element-1248" data-mp="1u9d84rfogls8">
                Except Brenden Henry provided{' '}
                <span className="text-stone-100 font-bold not-italic" data-id="element-1249" data-mp="1pbbnw36imgf6">
                  60+ scientific citations
                </span>{' '}
                to real studies in a video proving Vesugen's effectiveness for
                vascular health.
              </p>

              <p data-id="element-1250" data-mp="3rzjrdddygqrj">
                Most "influencers" and "experts" take the generic, surface-level
                approach of recommending BPC-157 for almost everything…
              </p>

              <p className="text-stone-100 font-bold" data-id="element-1251" data-mp="nk24h0tyspy3">
                And ChatGPT simply followed suit.
              </p>

              <p data-id="element-1252" data-mp="si3q9tirz3d9">
                It just... guessed. Based on all the data it's been trained on.
              </p>

              <p className="text-2xl font-bold text-red-500" data-id="element-1253" data-mp="ejcdqbjk9pr8">
                And it's largely BS.
              </p>
            </div>
          </div>

          {/* Divider */}
          <div className="flex items-center justify-center gap-4 py-8 sm:py-12 mt-8 sm:mt-16" data-id="element-1254" data-mp="2z91r0k4m93ht">
            <div className="w-24 h-px bg-gradient-to-r from-transparent via-amber-600/50 to-amber-600/50" data-id="element-1255" data-mp="349z9kxtjfzju" />
            <div className="w-2 h-2 bg-amber-600 rotate-45" data-id="element-1256" data-mp="22awdpwh4wqn5" />
            <div className="w-24 h-px bg-gradient-to-l from-transparent via-amber-600/50 to-amber-600/50" data-id="element-1257" data-mp="27a98d3e8z20a" />
          </div>

          {/* Section 3: Inventing New Peptides */}
          <div className="space-y-8" data-id="element-1258" data-mp="2c80wdmbru3z7">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-center text-stone-100 leading-tight" style={{
            fontFamily: 'Cinzel, serif'
          }} data-id="element-1259" data-mp="2gbqim54z49h2">
              <span className="text-yellow-400" style={{
              textShadow: '0 0 30px rgba(234, 179, 8, 0.4)'
            }} data-id="element-1260" data-mp="1okst19xwl4zt">
                AI Does Not Know What It's Saying
              </span>
              {' - '}
              <span className="text-yellow-300" data-id="element-1261" data-mp="10tni996tl2wd">Example #2</span>
            </h3>

            <div className="text-lg md:text-xl text-stone-300 space-y-6 leading-relaxed" data-id="element-1262" data-mp="14vifa1hpwu4c">
              <p data-id="element-1263" data-mp="xdaulfj5hgfh">
                I recently asked ChatGPT for the best peptides for brain
                restoration.
              </p>

              <p className="font-bold text-stone-100" data-id="element-1264" data-mp="se7nzqniv25e">It confidently listed:</p>

              <ul className="space-y-4 pl-4 border-l-2 border-stone-800 text-base sm:text-lg" data-id="element-1265" data-mp="ob1lmu3j5v47">
                <li data-id="element-1266" data-mp="jbydv1w61asj">
                  <span className="text-amber-500 font-bold" data-id="element-1267" data-mp="jchv0gdzrv5i">Bronchogen</span>{' '}
                  <span className="text-stone-400" data-id="element-1268" data-mp="eeygdfddtgd1">
                    (which, at the time of writing, has zero evidence in
                    scientific literature that it does ANYTHING for the brain)
                  </span>
                </li>
                <li data-id="element-1269" data-mp="4lr7vlnchk8q">
                  <span className="text-amber-500 font-bold" data-id="element-1270" data-mp="n1v9va4s6q5">Cardiogen</span>{' '}
                  <span className="text-stone-400" data-id="element-1271" data-mp="3rsth4igvkx75">
                    (while it's possible it could indirectly help restore the
                    brain, at the time of writing there's also no literature
                    backing up ChatGPT's assertion)
                  </span>
                </li>
              </ul>

              <p className="text-lg sm:text-xl text-stone-100 font-bold mt-6" data-id="element-1272" data-mp="3i5qp09frt61n">
                But then it listed a peptide called "Cortexgen"
              </p>

              {/* Image */}
              <div className="relative my-8 max-w-2xl mx-auto" data-id="element-1273" data-mp="386rqhjopyqsd">
                <div className="absolute -inset-1 bg-gradient-to-r from-amber-600/20 to-red-600/20 rounded-lg blur opacity-75" data-id="element-1274" data-mp="38943difmeayk" />
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3nt8h71t9XkgavNxaiVqUD/ChatGPTCortexgenHallucination.png" alt="ChatGPT hallucinating Cortexgen" className="relative rounded-lg border border-stone-800 w-full" data-id="element-1275" data-mp="4q1bifb5t3ej" />
              </div>

              <p className="text-2xl font-bold text-red-500 text-center" data-id="element-1276" data-mp="ip11preblqct">
                Except "Cortexgen" doesn't exist.
              </p>

              <p className="text-center font-medium text-stone-100" data-id="element-1277" data-mp="nivj2o6gdt8q">
                It just... made it up.
              </p>

              <p data-id="element-1278" data-mp="238e89hxxj0po">
                Probably mashed together Cortexin and Cortagen in its neural
                network and spit out a fake name.
              </p>

              <p className="text-xl font-bold text-stone-100 border-b-2 border-amber-600/30 pb-2 inline-block" data-id="element-1279" data-mp="2hw7s5eu1spe2">
                But that's not the worst of it...
              </p>
            </div>
          </div>

          {/* Divider */}
          <div className="flex items-center justify-center gap-4 py-8 sm:py-12 mt-16 sm:mt-20" data-id="element-1280" data-mp="1k9ij4l0xhcip">
            <div className="w-32 h-px bg-gradient-to-r from-transparent via-amber-600/50 to-amber-600/50" data-id="element-1281" data-mp="1y8ryjihb82lm" />
            <div className="w-2 h-2 bg-amber-600 rotate-45" data-id="element-1282" data-mp="1u6wva8ftjf57" />
            <div className="w-32 h-px bg-gradient-to-l from-transparent via-amber-600/50 to-amber-600/50" data-id="element-1283" data-mp="1u9j040bbrgjq" />
          </div>

          {/* NEW SECTION: And Humans Are Making It Worse */}
          <div className="space-y-8" data-id="element-1284" data-mp="35mbtffjrkd1w">
            <h3 className="text-3xl md:text-4xl font-serif font-bold text-center text-stone-100 mb-8" style={{
            fontFamily: 'Cinzel, serif',
            textShadow: '0 0 20px rgba(217, 119, 6, 0.2)'
          }} data-id="element-1285" data-mp="4rnjvaqxp8ea">
              Because Humans Are Making It{' '}
              <span className="text-red-500" style={{
              textShadow: '0 0 30px rgba(239, 68, 68, 0.5)'
            }} data-id="element-1286" data-mp="is6n84kgfqa4">
                Worse
              </span>
            </h3>

            <div className="text-lg md:text-xl text-stone-300 space-y-6 leading-relaxed" data-id="element-1287" data-mp="rpgznt90dlgm">
              <p className="text-stone-100 font-semibold" data-id="element-1288" data-mp="wkmvbjs7qehw">
                Here's the thing: Even if YOU don't use AI and you don't have to
                deal with its hallucinations directly...
              </p>

              <p className="text-stone-100 font-semibold" data-id="element-1289" data-mp="16ewqtacgbswu">
                Here's the thing...
              </p>

              <p className="text-amber-500 font-bold" style={{
              textShadow: '0 0 20px rgba(217, 119, 6, 0.3)'
            }} data-id="element-1290" data-mp="2vxli0kzjsswk">
                Most influencers (and even many experts) don't fact-check.
              </p>

              <div className="pl-4 sm:pl-6 border-l-2 border-amber-600/30 space-y-3" data-id="element-1291" data-mp="2h0m289ujltr0">
                <p data-id="element-1292" data-mp="2h2yrl82mr6e3">They pull up ChatGPT.</p>
                <p data-id="element-1293" data-mp="3eome919aaacf">Ask it to summarize a topic.</p>
                <p data-id="element-1294" data-mp="3eqfoeqj3vcp6">Record a video reading the AI script.</p>
                <p data-id="element-1295" data-mp="39qkusf7y490f">And assume it's correct.</p>
              </div>

              <p data-id="element-1296" data-mp="34y9s54ltm946">
                Because it{' '}
                <span className="font-bold text-stone-100 uppercase" data-id="element-1297" data-mp="34wqe7knn0a5k">
                  SOUNDS
                </span>{' '}
                correct.
              </p>

              <p data-id="element-1298" data-mp="19q03n1axuxf">
                And their audience assumes{' '}
                <span className="font-bold text-stone-100 uppercase" data-id="element-1299" data-mp="3so48vx99ghtp">THEY</span>{' '}
                did the research.
              </p>

              <p className="text-xl font-bold text-stone-100" data-id="element-1300" data-mp="1qrmx9rag958z">
                But they didn't.
              </p>

              <p className="text-xl font-bold text-stone-100" data-id="element-1301" data-mp="1vodg2mdn2ey3">Nobody did.</p>

              <p className="text-stone-100 italic" data-id="element-1302" data-mp="1h1k49r3bvran">
                And everyone is just putting the responsibility on someone (or
                some<span className="font-bold" data-id="element-1303" data-mp="1ly0woxhk8rtj">THING</span>) else.
              </p>
            </div>
          </div>

          {/* Divider */}
          <div className="flex items-center justify-center gap-4 py-8 sm:py-12 mt-8 sm:mt-16" data-id="element-1304" data-mp="1c1fqw9xpvcon">
            <div className="w-24 h-px bg-gradient-to-r from-transparent via-amber-600/50 to-amber-600/50" data-id="element-1305" data-mp="y267z2i4m4gz" />
            <div className="w-2 h-2 bg-amber-600 rotate-45" data-id="element-1306" data-mp="130hi7ecc2gzq" />
            <div className="w-24 h-px bg-gradient-to-l from-transparent via-amber-600/50 to-amber-600/50" data-id="element-1307" data-mp="1333qxhayn2jj" />
          </div>

          {/* NEW SECTION: The Feedback Loop From Hell */}
          <div className="space-y-8" data-id="element-1308" data-mp="2xeije5vcvg2z">
            <h3 className="text-3xl md:text-4xl font-serif font-bold text-center text-stone-100 mb-8" style={{
            fontFamily: 'Cinzel, serif',
            textShadow: '0 0 20px rgba(217, 119, 6, 0.2)'
          }} data-id="element-1309" data-mp="lrosam3l70iz">
              The Feedback Loop From{' '}
              <span className="text-red-500" style={{
              textShadow: '0 0 30px rgba(239, 68, 68, 0.5)'
            }} data-id="element-1310" data-mp="qqi48a386jh1">
                Hell
              </span>
            </h3>

            <div className="text-lg md:text-xl text-stone-300 space-y-6 leading-relaxed" data-id="element-1311" data-mp="zitvtza2scyl">
              <p className="text-stone-100 font-semibold" data-id="element-1312" data-mp="1efudtb2gstjv">
                Here's what's happening in real-time:
              </p>

              <div className="space-y-4 pl-4 sm:pl-6 border-l-2 border-red-600/50 text-base sm:text-lg" data-id="element-1313" data-mp="3g7piv7u7tzt4">
                <p data-id="element-1314" data-mp="3b8mfrsxsq3ns">→ AI or a human shares misinformation</p>
                <p data-id="element-1315" data-mp="3ba7b3krxpqmp">→ Humans spread it because it sounds right</p>
                <p data-id="element-1316" data-mp="2pg8jy9aff954">→ Humans generate more content with that misinformation</p>
                <p data-id="element-1317" data-mp="2uea5r1z8lmka">
                  → Other AI tools scrape that misinformation and use it to
                  generate even{' '}
                  <span className="font-bold text-stone-100 uppercase" data-id="element-1318" data-mp="2z6bfoh8xn175">
                    MORE
                  </span>{' '}
                  content
                </p>
                <p data-id="element-1319" data-mp="26h4e19e6lvho">→ That content gets indexed, shared, and trusted</p>
                <p data-id="element-1320" data-mp="26ixoz0vtv1vh">→ The cycle repeats</p>
              </div>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-1321" data-mp="2bgh1nwcvn6lb">
                Each iteration adds{' '}
                <span className="text-red-500 uppercase" data-id="element-1322" data-mp="2gdh8i9hjwddh">MORE</span> noise.
              </p>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-1323" data-mp="2khx8xv8easlb">
                Each iteration buries the truth{' '}
                <span className="text-red-500 uppercase" data-id="element-1324" data-mp="3rwa3k9be4sa8">DEEPER</span>.
              </p>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-1325" data-mp="3vxly8t94g3pa">
                Each iteration makes it harder to know what's real.
              </p>

              <p className="text-xl sm:text-2xl font-bold text-center text-amber-500 mt-6 sm:mt-8" style={{
              textShadow: '0 0 30px rgba(217, 119, 6, 0.4)'
            }} data-id="element-1326" data-mp="1g7na3mg1keo1">
                And your body pays the price.
              </p>
            </div>
          </div>

          {/* Divider */}

          {/* NEW SECTION: The Era of Accelerating Misinformation */}
          <motion.div ref={ref12} initial={{
          opacity: 0,
          y: 20
        }} animate={inView12 ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.4
        }} className="mt-20" data-id="element-1327" data-mp="wkpkj8w7jae2">
            {/* Divider */}
            <div className="flex items-center justify-center gap-4 mb-12" data-id="element-1328" data-mp="1vzhf4bhfmjm9">
              <div className="w-32 h-px bg-gradient-to-r from-transparent via-red-600/50 to-red-600/50" data-id="element-1329" data-mp="1r0eags5d6fet" />
              <div className="w-2 h-2 bg-red-600 rotate-45" data-id="element-1330" data-mp="1m0rzyqgx7d9p" />
              <div className="w-32 h-px bg-gradient-to-l from-transparent via-red-600/50 to-red-600/50" data-id="element-1331" data-mp="1m34cgo3wsvfd" />
            </div>

            <div className="space-y-6 text-lg md:text-xl leading-relaxed text-stone-300" data-id="element-1332" data-mp="2eppc0bujgdu0">
              <h3 className="text-3xl md:text-4xl font-serif font-bold text-center text-stone-100 mb-8" style={{
              fontFamily: 'Cinzel, serif',
              textShadow: '0 0 20px rgba(217, 119, 6, 0.2)'
            }} data-id="element-1333" data-mp="2erjs9cuv7hrr">
                The Era of{' '}
                <span className="text-red-500" style={{
                textShadow: '0 0 30px rgba(239, 68, 68, 0.5)'
              }} data-id="element-1334" data-mp="2xgqcj4bb4hfo">
                  Accelerating Misinformation
                </span>{' '}
                Is Already Here.
              </h3>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-1335" data-mp="k6q7wnfj4j5i">
                Let me show you how bad it's gotten.
              </p>

              <p data-id="element-1336" data-mp="o9v8gkg1uari">You just saw that AI-generated YouTube channel.</p>

              <p data-id="element-1337" data-mp="t86iav6cgl9q">The one that hallucinated FDR onto Mount Rushmore.</p>

              <p className="text-stone-100 font-semibold" data-id="element-1338" data-mp="y4n6tqhgh1nc">
                That video has been viewed thousands of times.
              </p>

              <p className="text-stone-100 font-semibold" data-id="element-1339" data-mp="132opwbevt0yt">
                And almost nobody in the comments caught the error.
              </p>

              <div className="pl-4 sm:pl-6 border-l-2 border-red-600/50 space-y-4 my-6 sm:my-8 text-base sm:text-lg" data-id="element-1340" data-mp="1bxmnvwwvz3x0">
                <p className="text-stone-100" data-id="element-1341" data-mp="1gx91w8kjgo6v">
                  Which means thousands of people now "know" that FDR is on
                  Mount Rushmore.
                </p>

                <p data-id="element-1342" data-mp="3hxvx706t6ti1">They'll repeat it.</p>

                <p data-id="element-1343" data-mp="3hyoyvmqwustb">They'll share it.</p>

                <p data-id="element-1344" data-mp="3czm36swtlyy0">They'll use it as a "fact" in THEIR content.</p>

                <p className="text-red-400 font-bold" data-id="element-1345" data-mp="3cx9dftktmkae">
                  And the misinformation spreads.
                </p>
              </div>

              <p className="text-xl md:text-2xl font-bold text-stone-100 mt-6 sm:mt-8" data-id="element-1346" data-mp="3mx0bg58lbhf8">
                Now imagine that same process happening with peptides.
              </p>

              <div className="pl-4 sm:pl-6 border-l-2 border-amber-600/30 space-y-3 text-base sm:text-lg" data-id="element-1347" data-mp="hxnbf44ck5t">
                <p data-id="element-1348" data-mp="ehgi767x5z06">With dosing protocols.</p>
                <p data-id="element-1349" data-mp="eh6s7imvjruh">With drug interactions.</p>
                <p data-id="element-1350" data-mp="9ilzs5dv6cgl">With contraindications.</p>
                <p data-id="element-1351" data-mp="9jx549myjs9t">With mechanisms of action.</p>
              </div>

              <p className="text-lg sm:text-xl font-bold text-stone-100 mt-6" data-id="element-1352" data-mp="2g8jvk3971rof">
                Except instead of just getting history wrong...
              </p>

              <p className="text-xl sm:text-2xl font-bold text-red-500" style={{
              textShadow: '0 0 30px rgba(239, 68, 68, 0.5)'
            }} data-id="element-1353" data-mp="2bc34p1am0z7n">
                People are putting the WRONG molecules into their bodies.
              </p>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-1354" data-mp="h0af0a3ywu8b">
                Or worse...
              </p>

              <p className="text-lg sm:text-xl font-bold text-red-400" data-id="element-1355" data-mp="81q783zy44yv">
                Recommending the wrong molecules to their clients.
              </p>

              <div className="bg-red-950/20 border-l-4 border-red-600 p-4 sm:p-6 my-6 sm:my-8 space-y-4 text-base sm:text-lg" data-id="element-1356" data-mp="d1unpu0uszp3">
                <p className="text-stone-100" data-id="element-1357" data-mp="32dkrkczkzwt">
                  Based on information that was hallucinated by an AI...
                </p>
                <p className="text-stone-100" data-id="element-1358" data-mp="1sicyzfvgpfjb">
                  Spread by an influencer who didn't fact-check...
                </p>
                <p className="text-stone-100" data-id="element-1359" data-mp="1xeadrhr2udtz">
                  Validated by MORE AI that scraped the bad information...
                </p>
                <p className="text-stone-100" data-id="element-1360" data-mp="3pheh0l1ad4jr">
                  And reinforced by thousands of people who believed it because
                  it SOUNDED right.
                </p>
              </div>
            </div>
          </motion.div>

          {/* NEW SECTION: Most People Are Working With the WRONG MAP */}
          <motion.div ref={ref13} initial={{
          opacity: 0,
          y: 20
        }} animate={inView13 ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.4
        }} className="mt-20" data-id="element-1361" data-mp="3alp0h2evdjmf">
            {/* Divider */}
            <div className="flex items-center justify-center gap-4 mb-12" data-id="element-1362" data-mp="2rw0alnpvktdx">
              <div className="w-32 h-px bg-gradient-to-r from-transparent via-amber-600/50 to-amber-600/50" data-id="element-1363" data-mp="2mvupkqe4254t" />
              <div className="w-2 h-2 bg-amber-600 rotate-45" data-id="element-1364" data-mp="2ct8lakq0j3sf" />
              <div className="w-32 h-px bg-gradient-to-l from-transparent via-amber-600/50 to-amber-600/50" data-id="element-1365" data-mp="2hp7huvlhvs3x" />
            </div>

            <div className="space-y-6 text-lg md:text-xl leading-relaxed text-stone-300" data-id="element-1366" data-mp="2mq3gatn2um1y">
              <h3 className="text-3xl md:text-4xl font-serif font-bold text-center text-stone-100 mb-8" style={{
              fontFamily: 'Cinzel, serif',
              textShadow: '0 0 20px rgba(217, 119, 6, 0.2)'
            }} data-id="element-1367" data-mp="2rnwottburs5e">
                Most People Are Working With the{' '}
                <span className="text-amber-500" style={{
                textShadow: '0 0 30px rgba(217, 119, 6, 0.5)'
              }} data-id="element-1368" data-mp="28pamyc8ihx0f">
                  WRONG MAP
                </span>
              </h3>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-1369" data-mp="1g7590ohpugm1">
                Let me show you what I mean.
              </p>

              <p data-id="element-1370" data-mp="13a0jnx1sx6fh">
                Most people think the problem with peptides is just "bad
                information."
              </p>

              <div className="pl-4 sm:pl-6 border-l-2 border-amber-600/30 space-y-3" data-id="element-1371" data-mp="1hxtzniusuayl">
                <p data-id="element-1372" data-mp="1d0lbn1myzcpf">Like if you could just filter out the noise...</p>
                <p data-id="element-1373" data-mp="p96855jgipcl">Find the "good sources"...</p>
                <p data-id="element-1374" data-mp="p9y1sathud08">Follow the "right protocols"...</p>
                <p data-id="element-1375" data-mp="kb4rssdf144t">Then you'd be set.</p>
              </div>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-1376" data-mp="kczae017sk5q">
                But that's not how this works.
              </p>

              <p className="text-stone-100 font-semibold" data-id="element-1377" data-mp="u8j3yfsb36rb">
                Because even the BEST information out there...
              </p>

              <p data-id="element-1378" data-mp="2al7nmrgirw6k">Even from the most "credible" experts...</p>

              <p data-id="element-1379" data-mp="25oqxjrprf7qu">
                Even from doctors with fancy credentials and big followings...
              </p>

              <p className="text-xl sm:text-2xl font-bold text-amber-500" style={{
              textShadow: '0 0 30px rgba(217, 119, 6, 0.4)'
            }} data-id="element-1380" data-mp="2d6p6nv414gtj">
                Is still missing the most important pieces.
              </p>

              <div className="bg-stone-950/50 border-2 border-amber-600/30 p-6 sm:p-8 my-6 sm:my-8" data-id="element-1381" data-mp="289f9tueb92vo">
                <p className="text-lg sm:text-xl font-bold text-stone-100 mb-4 sm:mb-6" data-id="element-1382" data-mp="2vz9jk33c2bbp">
                  Here's what they DON'T have:
                </p>

                <div className="space-y-4 text-base sm:text-lg" data-id="element-1383" data-mp="2n5whobnajzdh">
                  <div className="flex items-start gap-3" data-id="element-1384" data-mp="2n5eeev27okw2">
                    <XCircle className="w-5 h-5 sm:w-6 sm:h-6 text-amber-500 flex-shrink-0 mt-1" data-id="element-1385" data-mp="2r6gh5lvc7f2s" />
                    <p className="text-stone-300" data-id="element-1386" data-mp="3ewkkds4m5ct9">
                      Access to and understanding of original Russian research
                      papers (most of it has NEVER been translated to English)
                    </p>
                  </div>

                  <div className="flex items-start gap-3" data-id="element-1387" data-mp="2uypuqxmz1wfu">
                    <XCircle className="w-5 h-5 sm:w-6 sm:h-6 text-amber-500 flex-shrink-0 mt-1" data-id="element-1388" data-mp="2q5ekemiyaxj6" />
                    <p className="text-stone-300" data-id="element-1389" data-mp="2l7v6jnq60mrr">
                      Understanding of all three types of bioregulators (they
                      only know about Version 1)
                    </p>
                  </div>

                  <div className="flex items-start gap-3" data-id="element-1390" data-mp="3dtoa3zjac5fl">
                    <XCircle className="w-5 h-5 sm:w-6 sm:h-6 text-amber-500 flex-shrink-0 mt-1" data-id="element-1391" data-mp="38xpj046ko9bh" />
                    <p className="text-stone-300" data-id="element-1392" data-mp="33wjnxzpfw9ys">
                      Knowledge of the "super peptides" Brenden identified
                      (bioaugmentors that almost nobody else knows exist)
                    </p>
                  </div>

                  <div className="flex items-start gap-3" data-id="element-1393" data-mp="1sg1qbwa3w1ak">
                    <XCircle className="w-5 h-5 sm:w-6 sm:h-6 text-amber-500 flex-shrink-0 mt-1" data-id="element-1394" data-mp="1nijqqwhzayf8" />
                    <p className="text-stone-300" data-id="element-1395" data-mp="32lkh2ndwsjq">
                      Real-world experience creating "impossible"
                      transformations (they're working from theory, not proven
                      results)
                    </p>
                  </div>

                  <div className="flex items-start gap-3" data-id="element-1396" data-mp="hqggarwovd11">
                    <XCircle className="w-5 h-5 sm:w-6 sm:h-6 text-amber-500 flex-shrink-0 mt-1" data-id="element-1397" data-mp="hrzxqlu2zu4e" />
                    <p className="text-stone-300" data-id="element-1398" data-mp="mrm9equ9h2b3">
                      The diagnostic frameworks that allow you to spot root
                      causes instead of just treating symptoms
                    </p>
                  </div>
                </div>
              </div>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-1399" data-mp="10o9jzwf4zqzh">
                So when they teach peptides...
              </p>

              <p data-id="element-1400" data-mp="32g5ssy9x6mqk">When they recommend protocols...</p>

              <p data-id="element-1401" data-mp="32gxnm6vp0gfs">When they answer your questions...</p>

              <p className="text-stone-100 font-semibold" data-id="element-1402" data-mp="2o1nyqjten074">
                They're giving you the BEST answer they can...
              </p>

              <p className="text-xl sm:text-2xl font-bold text-amber-500" style={{
              textShadow: '0 0 30px rgba(217, 119, 6, 0.4)'
            }} data-id="element-1403" data-mp="2suh499wp6ck9">
                Based on an incomplete understanding of what's actually
                possible.
              </p>

              <div className="bg-gradient-to-br from-amber-950/30 to-black border-2 border-amber-600 p-6 sm:p-8 md:p-10 mt-6 sm:mt-8 relative" data-id="element-1404" data-mp="36qujecdre1vk">
                <div className="absolute top-0 left-0 w-6 sm:w-8 h-6 sm:h-8 border-l-2 border-t-2 border-amber-600" data-id="element-1405" data-mp="2wthmaq7cpb67" />
                <div className="absolute top-0 right-0 w-6 sm:w-8 h-6 sm:h-8 border-r-2 border-t-2 border-amber-600" data-id="element-1406" data-mp="31s19etxokt05" />
                <div className="absolute bottom-0 left-0 w-6 sm:w-8 h-6 sm:h-8 border-l-2 border-b-2 border-amber-600" data-id="element-1407" data-mp="1lhgtn07d92l6" />
                <div className="absolute bottom-0 right-0 w-6 sm:w-8 h-6 sm:h-8 border-r-2 border-b-2 border-amber-600" data-id="element-1408" data-mp="8gu16quxap61" />

                <p className="text-xl sm:text-2xl md:text-3xl text-center text-stone-100 font-bold leading-relaxed" style={{
                textShadow: '0 0 20px rgba(217, 119, 6, 0.3)'
              }} data-id="element-1409" data-mp="3iis4icgciov">
                  It's like trying to navigate with a map that's missing half
                  the territory.
                </p>
              </div>

              <p className="text-lg sm:text-xl text-stone-100 mt-6 sm:mt-8" data-id="element-1410" data-mp="3gxoy7pp1hfc7">
                You might get SOMEWHERE.
              </p>

              <p className="text-xl sm:text-2xl md:text-3xl font-bold text-center text-amber-500" style={{
              textShadow: '0 0 30px rgba(217, 119, 6, 0.4)'
            }} data-id="element-1411" data-mp="3uq52suxl9lf8">
                But you'll never reach the destinations that aren't even ON your
                map.
              </p>
            </div>
          </motion.div>

          {/* NEW SECTION: There's A Shift That MUST Happen */}
          <motion.div ref={ref14} initial={{
          opacity: 0,
          y: 20
        }} animate={inView14 ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.4
        }} className="mt-12 sm:mt-20" data-id="element-1412" data-mp="163a6ebwkunxp">
            {/* Divider with blue accent */}
            <div className="flex items-center justify-center gap-4 mb-8 sm:mb-12" data-id="element-1413" data-mp="s4ae8u9uvqws">
              <div className="w-16 sm:w-32 h-px bg-gradient-to-r from-transparent via-blue-500/50 to-blue-500/50" data-id="element-1414" data-mp="x3n47nw0xe3l" />
              <div className="w-2 h-2 bg-blue-500 rotate-45" data-id="element-1415" data-mp="23ks2w877op8v" />
              <div className="w-16 sm:w-32 h-px bg-gradient-to-l from-transparent via-blue-500/50 to-blue-500/50" data-id="element-1416" data-mp="23mbidwl1mw9l" />
            </div>

            <div className="space-y-6 text-lg md:text-xl leading-relaxed text-stone-300" data-id="element-1417" data-mp="3t1mbib6ie97o">
              <h3 className="text-2xl sm:text-3xl md:text-5xl font-serif font-bold text-center text-stone-100 mb-6 sm:mb-8 leading-tight" style={{
              fontFamily: 'Cinzel, serif',
              textShadow: '0 0 20px rgba(59, 130, 246, 0.3)'
            }} data-id="element-1418" data-mp="3o1hqq8ykisbn">
                There's A Shift That{' '}
                <span className="bg-gradient-to-r from-blue-400 via-cyan-400 to-blue-500 bg-clip-text text-transparent" style={{
                textShadow: '0 0 30px rgba(59, 130, 246, 0.5)'
              }} data-id="element-1419" data-mp="39asd6zxmx14m">
                  MUST
                </span>{' '}
                Happen
              </h3>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-1420" data-mp="yjr1kfk9bpvk">
                Here's what most people don't understand:
              </p>

              <p className="text-stone-100 font-semibold text-base sm:text-lg" data-id="element-1421" data-mp="3ne8hf58c3n43">
                You can't just "learn more information" and expect to operate at
                the level Brenden and Ali do.
              </p>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-1422" data-mp="3dgkkq9r645ja">
                Because mastery isn't about VOLUME of knowledge.
              </p>

              <p className="text-xl sm:text-2xl md:text-3xl font-bold text-center bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent" style={{
              textShadow: '0 0 30px rgba(59, 130, 246, 0.4)'
            }} data-id="element-1423" data-mp="3igp54av75kes">
                It's about the PARADIGM you're operating from.
              </p>

              <p className="text-lg sm:text-xl font-bold text-stone-100 mt-6 sm:mt-8" data-id="element-1424" data-mp="2zomj0jzsdbx5">
                Let me explain.
              </p>

              <div className="bg-gradient-to-br from-blue-950/30 via-stone-950/50 to-black border-l-4 border-blue-500/50 p-6 sm:p-8 my-6 sm:my-8" data-id="element-1425" data-mp="2ppxb9k1lt7um">
                <p className="text-lg sm:text-xl text-stone-100 font-bold mb-4" data-id="element-1426" data-mp="264x2p9ovso72">
                  Right now, most people (including most "experts") are
                  operating from a FRAGMENTED paradigm.
                </p>

                <div className="space-y-3 pl-4 sm:pl-6 border-l-2 border-blue-400/30 text-base sm:text-lg" data-id="element-1427" data-mp="2g08at95sax5u">
                  <p data-id="element-1428" data-mp="2p39e7239ma5t">They know bits and pieces.</p>
                  <p data-id="element-1429" data-mp="2p1y8gwq9esc2">They understand isolated mechanisms.</p>
                  <p data-id="element-1430" data-mp="2l27degtp9q1q">They can recommend protocols that "should" work.</p>
                </div>
              </div>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-1431" data-mp="2ytc772adzo45">
                But they don't have the COMPLETE PICTURE.
              </p>

              <div className="pl-4 sm:pl-6 border-l-2 border-blue-500/30 space-y-3 text-base sm:text-lg" data-id="element-1432" data-mp="2tw2hrmmzzcgb">
                <p data-id="element-1433" data-mp="38ovy1aa3fwm1">They've never seen the original research.</p>
                <p data-id="element-1434" data-mp="33tqf8kbzmy26">They don't understand how all the pieces fit together.</p>
                <p data-id="element-1435" data-mp="3aw54e4x0vsnf">
                  They don't know what's ACTUALLY possible when you understand
                  peptides at the highest level.
                </p>
              </div>

              <p className="text-stone-100 font-semibold text-base sm:text-lg" data-id="element-1436" data-mp="3kt1c48f3kaqx">
                So their "best recommendations" are still limited by their
                incomplete understanding.
              </p>

              <div className="bg-gradient-to-br from-stone-950/80 via-blue-950/20 to-black border-2 border-blue-500/30 p-6 sm:p-8 my-6 sm:my-8 relative" data-id="element-1437" data-mp="3uib65tti43ho">
                <div className="absolute top-0 left-0 w-5 sm:w-6 h-5 sm:h-6 border-l-2 border-t-2 border-blue-500/50" data-id="element-1438" data-mp="7en6oqays20q" />
                <div className="absolute top-0 right-0 w-5 sm:w-6 h-5 sm:h-6 border-r-2 border-t-2 border-blue-500/50" data-id="element-1439" data-mp="ce9jiymvrg90" />
                <div className="absolute bottom-0 left-0 w-5 sm:w-6 h-5 sm:h-6 border-l-2 border-b-2 border-blue-500/50" data-id="element-1440" data-mp="2971n1kxv0yf1" />
                <div className="absolute bottom-0 right-0 w-5 sm:w-6 h-5 sm:h-6 border-r-2 border-b-2 border-blue-500/50" data-id="element-1441" data-mp="2e5mkjclq93zs" />

                <p className="text-lg sm:text-xl md:text-2xl text-center text-stone-100 leading-relaxed italic" data-id="element-1442" data-mp="26neqi019sdy9">
                  It's like trying to complete a 1,000-piece puzzle...
                </p>
                <p className="text-lg sm:text-xl md:text-2xl text-center text-stone-100 mt-4 leading-relaxed italic" data-id="element-1443" data-mp="1wtftffg1zkd6">
                  When you've only been given 200 pieces.
                </p>
              </div>

              <p className="text-stone-100 text-base sm:text-lg" data-id="element-1444" data-mp="2klmidtjg8p2k">
                You can make SOMETHING.
              </p>

              <p className="text-xl sm:text-2xl font-bold text-blue-400" style={{
              textShadow: '0 0 30px rgba(59, 130, 246, 0.4)'
            }} data-id="element-1445" data-mp="2fl8jb0ztspgo">
                But it'll never be the full picture.
              </p>

              <div className="bg-gradient-to-br from-blue-950/30 via-cyan-950/20 to-black border-2 border-cyan-500 p-6 sm:p-8 md:p-10 mt-8 sm:mt-12 relative" data-id="element-1446" data-mp="z7ibbj5l5h1r">
                <div className="absolute top-0 left-0 w-6 sm:w-8 h-6 sm:h-8 border-l-2 border-t-2 border-cyan-500" data-id="element-1447" data-mp="1oyie0fy4gwcn" />
                <div className="absolute top-0 right-0 w-6 sm:w-8 h-6 sm:h-8 border-r-2 border-t-2 border-cyan-500" data-id="element-1448" data-mp="1fvhamn0n5jco" />
                <div className="absolute bottom-0 left-0 w-6 sm:w-8 h-6 sm:h-8 border-l-2 border-b-2 border-cyan-500" data-id="element-1449" data-mp="1jwj9h2qnbte4" />
                <div className="absolute bottom-0 right-0 w-6 sm:w-8 h-6 sm:h-8 border-r-2 border-b-2 border-cyan-500" data-id="element-1450" data-mp="27nor9ng5cvr2" />

                <p className="text-lg sm:text-xl md:text-2xl text-stone-100 font-bold mb-4" data-id="element-1451" data-mp="2ckymjjq7w1mt">
                  The paradigm shift is about getting ALL the pieces.
                </p>

                <div className="space-y-3 text-base sm:text-lg" data-id="element-1452" data-mp="22um1zriek8go">
                  <p className="text-stone-100" data-id="element-1453" data-mp="2qkznt0ae9b2t">
                    It's about seeing the COMPLETE map.
                  </p>
                  <p className="text-stone-100" data-id="element-1454" data-mp="2vd17h79w642v">
                    It's about understanding the PRINCIPLES behind the
                    protocols...
                  </p>
                  <p className="text-cyan-400 font-bold" style={{
                  textShadow: '0 0 20px rgba(34, 211, 238, 0.4)'
                }} data-id="element-1455" data-mp="eypft0k0hpyf">
                    So you can design your OWN solutions for ANY situation.
                  </p>
                </div>
              </div>

              <p className="text-lg sm:text-xl font-bold text-stone-100 mt-6 sm:mt-8" data-id="element-1456" data-mp="10hcmawdtset">
                This shift is what separates the masters from everyone else.
              </p>

              <p className="text-stone-100" data-id="element-1457" data-mp="axvqq3uu253y">
                And it's what allows Brenden and Ali to look at "hopeless"
                cases...
              </p>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-1458" data-mp="1may64vl74omj">
                And see exactly what needs to be done.
              </p>

              <div className="bg-gradient-to-br from-blue-950/30 to-black border-2 border-blue-500/40 p-6 sm:p-8 my-6 sm:my-8" data-id="element-1459" data-mp="1heqxgv1f0z0w">
                <p className="text-lg sm:text-xl text-blue-400 font-bold mb-4" data-id="element-1460" data-mp="2b21f8denfsud">
                  During PSI PRO, Brenden and Ali are going to GIVE you this
                  paradigm shift.
                </p>

                <div className="space-y-3 pl-4 sm:pl-6 border-l-2 border-cyan-500/30" data-id="element-1461" data-mp="2k1y7sq45tbup">
                  <p className="text-stone-100" data-id="element-1462" data-mp="2yzgvdp53pj0k">
                    They're going to show you the complete picture.
                  </p>
                  <p className="text-stone-100" data-id="element-1463" data-mp="2tzui5fp9w2rr">
                    They're going to reveal the principles that govern
                    biological optimization.
                  </p>
                  <p className="text-stone-100" data-id="element-1464" data-mp="33ri451328rlu">
                    They're going to teach you how to THINK like a master...
                  </p>
                  <p className="text-stone-100 italic" data-id="element-1465" data-mp="3hnvk25ry4ky7">
                    Not just follow templates like everyone else.
                  </p>
                </div>
              </div>

              <p className="text-xl sm:text-2xl md:text-3xl font-bold text-center text-cyan-400 mt-6 sm:mt-8" style={{
              textShadow: '0 0 30px rgba(34, 211, 238, 0.4)'
            }} data-id="element-1466" data-mp="8avosbicney">
                And once you make this shift...
              </p>

              <p className="text-xl sm:text-2xl md:text-3xl font-bold text-center text-stone-100" style={{
              textShadow: '0 0 20px rgba(59, 130, 246, 0.3)'
            }} data-id="element-1467" data-mp="3rfn8yw99sgpl">
                Everything changes.
              </p>

              <div className="space-y-4 pl-4 sm:pl-6 border-l-2 border-blue-500/30 mt-6 sm:mt-8 text-base sm:text-lg" data-id="element-1468" data-mp="33mexnhjer336">
                <p className="text-stone-100" data-id="element-1469" data-mp="2untk60ssme99">
                  You'll look at bloodwork differently.
                </p>
                <p className="text-stone-100" data-id="element-1470" data-mp="2yo3mn3hdmmjd">
                  You'll design protocols differently.
                </p>
                <p className="text-stone-100" data-id="element-1471" data-mp="1580o66q5toua">
                  You'll solve problems differently.
                </p>
                <p className="text-stone-100 font-bold" data-id="element-1472" data-mp="10dmpnvg7b1le">
                  You'll operate at a level most practitioners will NEVER reach.
                </p>
              </div>

              <p className="text-lg sm:text-xl text-stone-100 text-center mt-6 sm:mt-8 italic" data-id="element-1473" data-mp="qj4i2f7nylwb">
                And you'll wonder how you ever functioned without seeing the
                full picture.
              </p>
            </div>
          </motion.div>

          {/* NEW SECTION: Accessing Powers Beyond The Mainstream */}
          <motion.div ref={ref15} initial={{
          opacity: 0,
          y: 20
        }} animate={inView15 ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.4
        }} className="mt-12 sm:mt-20" data-id="element-1474" data-mp="1e8yw303pygi5">
            {/* Divider with purple/green gradient */}
            <div className="flex items-center justify-center gap-4 mb-8 sm:mb-12" data-id="element-1475" data-mp="2ed80bymtsya9">
              <div className="w-16 sm:w-32 h-px bg-gradient-to-r from-transparent via-purple-500/50 to-green-500/50" data-id="element-1476" data-mp="2jcufidm7solp" />
              <div className="w-2 h-2 bg-gradient-to-br from-purple-500 to-green-500 rotate-45" data-id="element-1477" data-mp="2o76yynnoxzxg" />
              <div className="w-16 sm:w-32 h-px bg-gradient-to-l from-transparent via-green-500/50 to-purple-500/50" data-id="element-1478" data-mp="2t6b5t7n57lkm" />
            </div>

            <div className="space-y-6 text-lg md:text-xl leading-relaxed text-stone-300" data-id="element-1479" data-mp="324dg6dsrnqkk">
              <h3 className="text-2xl sm:text-3xl md:text-5xl font-serif font-bold text-center text-stone-100 mb-6 sm:mb-8 leading-tight" style={{
              fontFamily: 'Cinzel, serif',
              textShadow: '0 0 20px rgba(168, 85, 247, 0.3)'
            }} data-id="element-1480" data-mp="373pziokfifie">
                This Is About Accessing{' '}
                <span className="bg-gradient-to-r from-purple-400 via-pink-400 to-green-400 bg-clip-text text-transparent" style={{
                textShadow: '0 0 30px rgba(168, 85, 247, 0.5)'
              }} data-id="element-1481" data-mp="hhlhx9a7d1xa">
                  Powers Beyond The Mainstream
                </span>
              </h3>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-1482" data-mp="3uvgj2dhlykrx">
                Let me be clear about what I mean.
              </p>

              <p className="text-stone-100" data-id="element-1483" data-mp="8f3uirita38p">
                When I say "powers beyond the mainstream"...
              </p>

              <p className="text-xl sm:text-2xl font-bold text-stone-100" data-id="element-1484" data-mp="3nu61u9015ye">
                I'm not talking about some woo-woo mystical bullsh**t.
              </p>

              <p className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-purple-400 to-green-400 bg-clip-text text-transparent" style={{
              textShadow: '0 0 30px rgba(168, 85, 247, 0.4)'
            }} data-id="element-1485" data-mp="3c1uecpd2jp5c">
                I'm talking about biological capabilities that are
                scientifically validated...
              </p>

              <p className="text-lg sm:text-xl text-stone-100 font-semibold" data-id="element-1486" data-mp="1hnyowmfh2co3">
                But almost completely unknown outside of elite research circles.
              </p>

              <div className="bg-gradient-to-br from-purple-950/30 via-stone-950/50 to-green-950/20 border-2 border-purple-500/40 p-6 sm:p-8 my-6 sm:my-8" data-id="element-1487" data-mp="25ecmesgtt3q2">
                <p className="text-lg sm:text-xl font-bold text-purple-400 mb-4 sm:mb-6" data-id="element-1488" data-mp="1wdmptmjqr9ba">
                  Capabilities like:
                </p>

                <div className="space-y-4 text-base sm:text-lg" data-id="element-1489" data-mp="20gje9tvypzn5">
                  <div className="flex items-start gap-3" data-id="element-1490" data-mp="kwws6rtdvpta">
                    <span className="text-green-400 text-xl flex-shrink-0" data-id="element-1491" data-mp="oz1knn83igec">
                      →
                    </span>
                    <p className="text-stone-100" data-id="element-1492" data-mp="2rkx32behe09f">
                      Reversing cognitive decline that neurologists said was
                      "permanent"
                    </p>
                  </div>

                  <div className="flex items-start gap-3" data-id="element-1493" data-mp="2huud6k2np2fb">
                    <span className="text-green-400 text-xl flex-shrink-0" data-id="element-1494" data-mp="2cxc0ciliq321">
                      →
                    </span>
                    <p className="text-stone-100" data-id="element-1495" data-mp="28wid7rfwgsa7">
                      Restoring heart function that cardiologists said required
                      a transplant
                    </p>
                  </div>

                  <div className="flex items-start gap-3" data-id="element-1496" data-mp="1yy2mvqop5n1r">
                    <span className="text-green-400 text-xl flex-shrink-0" data-id="element-1497" data-mp="1tygblmsfigvl">
                      →
                    </span>
                    <p className="text-stone-100" data-id="element-1498" data-mp="3ta9a5nuv7uaf">
                      Regenerating tissues that mainstream medicine considers
                      "impossible to heal"
                    </p>
                  </div>

                  <div className="flex items-start gap-3" data-id="element-1499" data-mp="nc65ct2kr6j">
                    <span className="text-green-400 text-xl flex-shrink-0" data-id="element-1500" data-mp="4oxjez9in7h9">
                      →
                    </span>
                    <p className="text-stone-100" data-id="element-1501" data-mp="9hgspk167gg9">
                      Optimizing biological markers in ways that make doctors
                      ask "what are you doing?"
                    </p>
                  </div>

                  <div className="flex items-start gap-3" data-id="element-1502" data-mp="3dwgn9b1mdn72">
                    <span className="text-green-400 text-xl flex-shrink-0" data-id="element-1503" data-mp="3hx0j8bagikrm">
                      →
                    </span>
                    <p className="text-stone-100" data-id="element-1504" data-mp="3mtqxct2pb6ae">
                      Accessing energy, clarity, and performance levels you
                      didn't know were possible
                    </p>
                  </div>
                </div>
              </div>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-1505" data-mp="1734pi61jg0sb">
                This isn't theory.
              </p>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-1506" data-mp="1s8hxihyqo9rt">
                This isn't speculation.
              </p>

              <p className="text-xl sm:text-2xl font-bold text-center bg-gradient-to-r from-purple-400 to-green-400 bg-clip-text text-transparent" style={{
              textShadow: '0 0 30px rgba(168, 85, 247, 0.4)'
            }} data-id="element-1507" data-mp="1o4k2aicjbj41">
                This is what happens when you understand peptides and compounds
                at the level Brenden and Ali do.
              </p>

              <div className="space-y-4 pl-4 sm:pl-6 border-l-2 border-purple-500/30 mt-6 sm:mt-8 text-base sm:text-lg" data-id="element-1508" data-mp="2kwvz17p1do84">
                <p className="text-stone-100" data-id="element-1509" data-mp="2fyucgcsej6rw">
                  When you know which molecules to use.
                </p>
                <p className="text-stone-100" data-id="element-1510" data-mp="qkpaz8b1ncye">
                  How to stack them for synergistic effects.
                </p>
                <p className="text-stone-100" data-id="element-1511" data-mp="2x754y52r22z5">
                  How to dose them for maximum bioavailability.
                </p>
                <p className="text-stone-100" data-id="element-1512" data-mp="324wwgxzhfn2t">
                  How to sequence them for optimal results.
                </p>
              </div>

              <p className="text-lg sm:text-xl font-bold text-stone-100 mt-6 sm:mt-8" data-id="element-1513" data-mp="2ocqqg4q1mwh3">
                And most importantly...
              </p>

              <div className="bg-gradient-to-br from-purple-950/30 via-green-950/20 to-black border-2 border-green-500 p-6 sm:p-8 md:p-10 mt-6 sm:mt-8 relative" data-id="element-1514" data-mp="2eg441bi2jxcy">
                <div className="absolute top-0 left-0 w-6 sm:w-8 h-6 sm:h-8 border-l-2 border-t-2 border-purple-500" data-id="element-1515" data-mp="25fp8zkfaz3w9" />
                <div className="absolute top-0 right-0 w-6 sm:w-8 h-6 sm:h-8 border-r-2 border-t-2 border-green-500" data-id="element-1516" data-mp="29gr88197zfy8" />
                <div className="absolute bottom-0 left-0 w-6 sm:w-8 h-6 sm:h-8 border-l-2 border-b-2 border-green-500" data-id="element-1517" data-mp="3pdse1jd3ezv" />
                <div className="absolute bottom-0 right-0 w-6 sm:w-8 h-6 sm:h-8 border-r-2 border-b-2 border-purple-500" data-id="element-1518" data-mp="7pe77nadhs7g" />

                <p className="text-xl sm:text-2xl md:text-3xl text-center bg-gradient-to-r from-purple-400 via-pink-400 to-green-400 bg-clip-text text-transparent font-bold leading-relaxed" style={{
                textShadow: '0 0 30px rgba(168, 85, 247, 0.5)'
              }} data-id="element-1519" data-mp="1ad8n5v4sx1a1">
                  When you understand the Precision Cell™ method.
                </p>
              </div>
            </div>
          </motion.div>

          {/* NEW SECTION: The Precision Cell™ Method */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="mt-20 sm:mt-32" data-id="element-1520" data-mp="233h9lz6de7uf">
            {/* Dramatic Divider with Emerald/Teal gradient */}
            <div className="flex items-center justify-center gap-4 mb-10 sm:mb-16" data-id="element-1521" data-mp="58txvz9xjv8t">
              <div className="w-16 sm:w-32 h-px bg-gradient-to-r from-transparent via-emerald-500/60 to-teal-500/60" data-id="element-1522" data-mp="gjyztqu7kue" />
              <motion.div animate={{
              scale: [1, 1.2, 1],
              rotate: [0, 180, 360]
            }} transition={{
              duration: 3,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="w-3 h-3 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-full" data-id="element-1523" data-mp="3roemxzc0duwh" />
              <div className="w-16 sm:w-32 h-px bg-gradient-to-l from-transparent via-teal-500/60 to-emerald-500/60" data-id="element-1524" data-mp="f4es3b8rbr80" />
            </div>

            {/* Main Headline - Dramatic and Eye-Catching */}
            <div className="relative mb-10 sm:mb-16" data-id="element-1525" data-mp="2zxs2esygu9i2">
              {/* Glowing background effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-emerald-600/20 via-teal-500/30 to-emerald-600/20 blur-3xl" data-id="element-1526" data-mp="2uvj89t9ux1ed" />

              <div className="relative" data-id="element-1527" data-mp="2wcgebrgm0cr4">
                <h3 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-serif font-bold text-center mb-6 leading-tight" style={{
                fontFamily: 'Cinzel, serif'
              }} data-id="element-1528" data-mp="31cb7y2rrrgfv">
                  <span className="block bg-gradient-to-r from-emerald-400 via-teal-400 to-emerald-500 bg-clip-text text-transparent" style={{
                  textShadow: '0 0 40px rgba(16, 185, 129, 0.6)'
                }} data-id="element-1529" data-mp="2dns17rodbbpw">
                    The Precision Cell™ Method:
                  </span>
                  <span className="block mt-2 sm:mt-4 text-stone-100" style={{
                  textShadow: '0 0 30px rgba(16, 185, 129, 0.3)'
                }} data-id="element-1530" data-mp="28oyklqdsb4li">
                    The Secret Weapon for
                  </span>
                  <span className="block mt-2 bg-gradient-to-r from-teal-400 to-emerald-400 bg-clip-text text-transparent" style={{
                  textShadow: '0 0 40px rgba(20, 184, 166, 0.6)'
                }} data-id="element-1531" data-mp="1g2h089uot5f2">
                    Biological Transformation
                  </span>
                </h3>

                {/* Decorative underline */}
                <motion.div initial={{
                scaleX: 0
              }} animate={{
                scaleX: 1
              }} transition={{
                duration: 1,
                delay: 0.5
              }} className="w-32 sm:w-64 h-1 bg-gradient-to-r from-transparent via-emerald-500 to-transparent mx-auto" data-id="element-1532" data-mp="1yyqeoy9i3xzl" />
              </div>
            </div>

            {/* Content */}
            <div className="space-y-6 sm:space-y-8 text-lg md:text-xl leading-relaxed text-stone-300 max-w-4xl mx-auto" data-id="element-1533" data-mp="b3k3z2hdbb3m">
              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-1534" data-mp="g1ll3hv8h0cg">
                Here's something most people don't know:
              </p>

              <p className="text-stone-100" data-id="element-1535" data-mp="kv80viwp1kch">
                When private clients pay us $15,000 to $120,000 for
                transformation work...
              </p>

              <p className="text-stone-100 font-semibold" data-id="element-1536" data-mp="3ob5bfsyroubc">
                They're not just "getting peptide protocols."
              </p>

              <div className="bg-gradient-to-br from-emerald-950/40 via-teal-950/30 to-black border-2 border-emerald-500/50 p-6 sm:p-8 my-6 sm:my-8 relative overflow-hidden" data-id="element-1537" data-mp="3taroa1aoo8jm">
                {/* Subtle animated background particles */}
                <div className="absolute inset-0 opacity-20" data-id="element-1538" data-mp="1cl2q7fkjxa15">
                  {[...Array(6)].map((_, i) => <motion.div key={i} className="absolute w-1 h-1 bg-emerald-400 rounded-full" style={{
                  left: `${20 + i * 15}%`,
                  top: `${30 + i % 3 * 20}%`
                }} animate={{
                  y: [-10, 10, -10],
                  opacity: [0.3, 1, 0.3]
                }} transition={{
                  duration: 3,
                  repeat: Infinity,
                  delay: i * 0.5,
                  ease: 'easeInOut'
                }} data-id="element-1539" data-mp="1hi2xtux1ukud" data-mpi={i} />)}
                </div>

                <p className="text-lg sm:text-xl md:text-2xl text-stone-100 font-bold mb-4 relative z-10" data-id="element-1540" data-mp="z0q8y95oad8r">
                  They're getting access to a proprietary methodology that we
                  have developed over years of real-world application.
                </p>

                <p className="text-xl sm:text-2xl md:text-3xl font-bold text-center mt-6 relative z-10" data-id="element-1541" data-mp="2pbkzlgujuyzq">
                  <span className="bg-gradient-to-r from-emerald-400 to-teal-400 bg-clip-text text-transparent" style={{
                  textShadow: '0 0 30px rgba(16, 185, 129, 0.5)'
                }} data-id="element-1542" data-mp="mn37onhpqpjs">
                    It's called the Precision Cell™ method.
                  </span>
                </p>
              </div>

              <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-1543" data-mp="15fozmwpi1vz3">
                And it's one of the reasons we can create transformations that
                seem impossible to everyone else.
              </p>

              {/* "Here's what it helps you to do" Section */}
              <div className="mt-8 sm:mt-12 mb-6 sm:mb-8" data-id="element-1544" data-mp="11bzhaozf4ami">
                <p className="text-xl sm:text-2xl md:text-3xl font-bold text-center text-emerald-400 mb-6 sm:mb-8" data-id="element-1545" data-mp="3h4q20jggjph0">
                  Here's what it helps you to do:
                </p>

                {/* Benefits List - Visually Strong */}
                <div className="space-y-4 sm:space-y-6" data-id="element-1546" data-mp="3dkxuzas307sw">
                  {/* Benefit 1 */}
                  <motion.div initial={{
                  opacity: 0,
                  x: -20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 0.5
                }} className="flex items-start gap-3 sm:gap-4 p-4 sm:p-6 bg-gradient-to-r from-emerald-950/30 to-transparent border-l-4 border-emerald-500 rounded-r-lg" data-id="element-1547" data-mp="39k5p8rif4l1d">
                    <span className="text-emerald-400 text-xl sm:text-2xl flex-shrink-0 font-bold" data-id="element-1548" data-mp="2c5jn69kfaq9w">
                      →
                    </span>
                    <p className="text-stone-100 text-base sm:text-lg" data-id="element-1549" data-mp="275nhm5w2uqs8">
                      Look at a "hopeless" case and see{' '}
                      <span className="font-bold text-emerald-400" data-id="element-1550" data-mp="1lp84ud01bpy8">
                        EXACTLY
                      </span>{' '}
                      what needs to be done{' '}
                      <span className="text-stone-400 italic" data-id="element-1551" data-mp="1vk04dmd6gmvn">
                        (while other practitioners are still guessing)
                      </span>
                    </p>
                  </motion.div>

                  {/* Benefit 2 */}
                  <motion.div initial={{
                  opacity: 0,
                  x: -20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 0.5,
                  delay: 0.1
                }} className="flex items-start gap-3 sm:gap-4 p-4 sm:p-6 bg-gradient-to-r from-teal-950/30 to-transparent border-l-4 border-teal-500 rounded-r-lg" data-id="element-1552" data-mp="29kkmegb9qeo3">
                    <span className="text-teal-400 text-xl sm:text-2xl flex-shrink-0 font-bold" data-id="element-1553" data-mp="cozthu1gwssu">
                      →
                    </span>
                    <p className="text-stone-100 text-base sm:text-lg" data-id="element-1554" data-mp="2phbvk915j3y">
                      Design protocols that work when everything else has failed{' '}
                      <span className="text-stone-400 italic" data-id="element-1555" data-mp="vd4qminmdfio">
                        (because you understand mechanisms at the molecular
                        level)
                      </span>
                    </p>
                  </motion.div>

                  {/* Benefit 3 */}
                  <motion.div initial={{
                  opacity: 0,
                  x: -20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 0.5,
                  delay: 0.2
                }} className="flex items-start gap-3 sm:gap-4 p-4 sm:p-6 bg-gradient-to-r from-emerald-950/30 to-transparent border-l-4 border-emerald-500 rounded-r-lg" data-id="element-1556" data-mp="llh5ezhnoupn">
                    <span className="text-emerald-400 text-xl sm:text-2xl flex-shrink-0 font-bold" data-id="element-1557" data-mp="w9thi4uywwpv">
                      →
                    </span>
                    <p className="text-stone-100 text-base sm:text-lg" data-id="element-1558" data-mp="mi7bqo1efpui">
                      Reverse conditions that mainstream medicine calls
                      "permanent"{' '}
                      <span className="text-stone-400 italic" data-id="element-1559" data-mp="dhr9fhwe6or8">
                        (because you know which tissues respond to which
                        peptides and how to sequence them for maximum effect)
                      </span>
                    </p>
                  </motion.div>

                  {/* Benefit 4 */}
                  <motion.div initial={{
                  opacity: 0,
                  x: -20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 0.5,
                  delay: 0.3
                }} className="flex items-start gap-3 sm:gap-4 p-4 sm:p-6 bg-gradient-to-r from-teal-950/30 to-transparent border-l-4 border-teal-500 rounded-r-lg" data-id="element-1560" data-mp="2p4baje348x5j">
                    <span className="text-teal-400 text-xl sm:text-2xl flex-shrink-0 font-bold" data-id="element-1561" data-mp="1ipk0ajs3rzyu">
                      →
                    </span>
                    <p className="text-stone-100 text-base sm:text-lg" data-id="element-1562" data-mp="1mpcfvgfwz6dp">
                      Optimize your biology (or your clients' biology) with the
                      kind of{' '}
                      <span className="font-bold text-teal-400" data-id="element-1563" data-mp="2l1x1v2j1fjtk">precision</span>{' '}
                      that creates measurable, undeniable results
                    </p>
                  </motion.div>

                  {/* Benefit 5 */}
                  <motion.div initial={{
                  opacity: 0,
                  x: -20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 0.5,
                  delay: 0.4
                }} className="flex items-start gap-3 sm:gap-4 p-4 sm:p-6 bg-gradient-to-r from-emerald-950/30 to-transparent border-l-4 border-emerald-500 rounded-r-lg" data-id="element-1564" data-mp="2uuvssr20bmgc">
                    <span className="text-emerald-400 text-xl sm:text-2xl flex-shrink-0 font-bold" data-id="element-1565" data-mp="3uzentfdzgff7">
                      →
                    </span>
                    <p className="text-stone-100 text-base sm:text-lg" data-id="element-1566" data-mp="3l31uwjq9i5li">
                      Operate{' '}
                      <span className="font-bold text-emerald-400" data-id="element-1567" data-mp="3q0todi6k1zrt">
                        10-20 years ahead
                      </span>{' '}
                      of mainstream medicine{' '}
                      <span className="text-stone-400 italic" data-id="element-1568" data-mp="mlfxat9s5m93">
                        (because you're not waiting for "official" validation)
                      </span>
                    </p>
                  </motion.div>
                </div>
              </div>

              {/* "This is the REAL value" Section */}
              <div className="bg-gradient-to-br from-teal-950/40 via-emerald-950/30 to-black border-2 border-teal-500/60 p-6 sm:p-8 md:p-10 my-8 sm:my-12 relative" data-id="element-1569" data-mp="10jmhx7ppxpqt">
                <div className="absolute top-0 left-0 w-8 sm:w-10 h-8 sm:h-10 border-l-2 border-t-2 border-teal-500" data-id="element-1570" data-mp="3ds724ce2hcfu" />
                <div className="absolute top-0 right-0 w-8 sm:w-10 h-8 sm:h-10 border-r-2 border-t-2 border-emerald-500" data-id="element-1571" data-mp="38t43b9ook2gb" />
                <div className="absolute bottom-0 left-0 w-8 sm:w-10 h-8 sm:h-10 border-l-2 border-b-2 border-emerald-500" data-id="element-1572" data-mp="33usvt5luy419" />
                <div className="absolute bottom-0 right-0 w-8 sm:w-10 h-8 sm:h-10 border-r-2 border-b-2 border-teal-500" data-id="element-1573" data-mp="2yxamhe3xhmsq" />

                <p className="text-xl sm:text-2xl md:text-3xl font-bold text-center text-teal-400 mb-4 sm:mb-6" data-id="element-1574" data-mp="3rk51vwlw1vzc">
                  This is the REAL value.
                </p>

                <div className="space-y-3 sm:space-y-4 text-center" data-id="element-1575" data-mp="3mr293qoxqqk7">
                  <p className="text-lg sm:text-xl text-stone-100" data-id="element-1576" data-mp="3htabqh5iuc8m">
                    Not just knowing{' '}
                    <span className="font-bold text-emerald-400" data-id="element-1577" data-mp="j5cxlpkb7d1l">WHAT</span>{' '}
                    peptides to use.
                  </p>

                  <p className="text-xl sm:text-2xl font-bold text-stone-100" data-id="element-1578" data-mp="mm918ue2jdtv">
                    But understanding <span className="text-teal-400" data-id="element-1579" data-mp="qnb3zl77280l">HOW</span>{' '}
                    to think about biology at the level Brenden and Ali do.
                  </p>
                </div>
              </div>

              {/* Final Value Proposition */}
              <div className="space-y-4 sm:space-y-6 mt-8 sm:mt-12" data-id="element-1580" data-mp="10nbr7i86p8a2">
                <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-1581" data-mp="15lmz3nex58pn">
                  And when you join PSI PRO...
                </p>

                <p className="text-xl sm:text-2xl md:text-3xl font-bold text-center bg-gradient-to-r from-emerald-400 to-teal-400 bg-clip-text text-transparent" data-id="element-1582" data-mp="19klzcuppghar">
                  You're getting the complete Precision Cell™ Pro methodology.
                </p>

                <div className="bg-gradient-to-br from-emerald-950/30 to-black border-l-4 border-emerald-500 p-6 sm:p-8 space-y-3 sm:space-y-4" data-id="element-1583" data-mp="1oce6ijfcip1e">
                  <p className="text-stone-100 flex items-start gap-3 text-base sm:text-lg" data-id="element-1584" data-mp="1t8biyenhnb8w">
                    <span className="text-emerald-400 flex-shrink-0" data-id="element-1585" data-mp="13k68hvk7il1z">✓</span>
                    <span data-id="element-1586" data-mp="yoqun3m78p5k">The same diagnostic frameworks.</span>
                  </p>
                  <p className="text-stone-100 flex items-start gap-3 text-base sm:text-lg" data-id="element-1587" data-mp="1dd54vzly3fw5">
                    <span className="text-emerald-400 flex-shrink-0" data-id="element-1588" data-mp="18kc2vjhv2lnr">✓</span>
                    <span data-id="element-1589" data-mp="1mc8rhdkbmdfe">The same protocol design principles.</span>
                  </p>
                  <p className="text-stone-100 flex items-start gap-3 text-base sm:text-lg" data-id="element-1590" data-mp="1hdxh91q460wn">
                    <span className="text-emerald-400 flex-shrink-0" data-id="element-1591" data-mp="1waxwi5r4c3e8">✓</span>
                    <span data-id="element-1592" data-mp="1w8v9lul9iqdq">The same optimization strategies.</span>
                  </p>
                </div>

                <div className="bg-gradient-to-br from-teal-950/40 via-emerald-950/30 to-black border-2 border-emerald-500 p-6 sm:p-8 md:p-10 mt-6 sm:mt-8 relative" data-id="element-1593" data-mp="1ra0js8ovo1k4">
                  <div className="absolute top-0 left-0 w-6 sm:w-8 h-6 sm:h-8 border-l-2 border-t-2 border-emerald-500" data-id="element-1594" data-mp="3t4sqiyvidlzn" />
                  <div className="absolute top-0 right-0 w-6 sm:w-8 h-6 sm:h-8 border-r-2 border-t-2 border-teal-500" data-id="element-1595" data-mp="28na2yh3m1to8" />
                  <div className="absolute bottom-0 left-0 w-6 sm:w-8 h-6 sm:h-8 border-l-2 border-b-2 border-teal-500" data-id="element-1596" data-mp="1yvdtk9w2qh4p" />
                  <div className="absolute bottom-0 right-0 w-6 sm:w-8 h-6 sm:h-8 border-r-2 border-b-2 border-emerald-500" data-id="element-1597" data-mp="23tp3slqa6tng" />

                  <p className="text-lg sm:text-xl md:text-2xl text-center text-stone-100 leading-relaxed" data-id="element-1598" data-mp="1ptwdusmkwhgj">
                    That private transformation clients paying upwards of{' '}
                    <span className="font-bold text-emerald-400 text-xl sm:text-2xl md:text-3xl" data-id="element-1599" data-mp="1fxjog6y2gprl">
                      $30,000
                    </span>{' '}
                    get access to.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Divider */}

          {/* NEW SECTION: You Can't Fact-Check Everything */}
          <div className="space-y-8" data-id="element-1600" data-mp="22311i1jvgt0y"></div>

          {/* Divider */}

          {/* NEW SECTION: The Signal Is Getting Weaker */}
          <div className="space-y-8" data-id="element-1601" data-mp="1y1piievi761q"></div>
        </div>
      </motion.div>

      {/* NEW SECTION: Agitation - Are You Experiencing Results */}

      {/* New Section: Misinformation Crisis */}
      <motion.div ref={ref3} initial={{
      opacity: 0,
      y: 20
    }} animate={inView3 ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.4
    }} className="relative z-10 max-w-4xl mx-auto mt-20 sm:mt-32" data-id="element-1602" data-mp="1oauw9ai9c6ga">
        {/* Decorative divider */}
        <div className="flex items-center justify-center gap-4 mb-8 sm:mb-12" data-id="element-1603" data-mp="15el9zzx7c9l7">
          <div className="w-16 sm:w-32 h-px bg-gradient-to-r from-transparent via-amber-600/50 to-amber-600/50" data-id="element-1604" data-mp="34p49b8h1u8rt" />
          <AlertTriangle className="w-6 h-6 sm:w-8 sm:h-8 text-amber-500" data-id="element-1605" data-mp="2zrb169w6r4ow" />
          <div className="w-16 sm:w-32 h-px bg-gradient-to-l from-transparent via-amber-600/50 to-amber-600/50" data-id="element-1606" data-mp="3799buhq3sltp" />
        </div>

        {/* Main headline - Split into two parts */}
        <div className="mb-8 sm:mb-12 text-center" data-id="element-1607" data-mp="3gzlsvzyplwv3">
          <h2 className="text-xl sm:text-2xl md:text-4xl font-serif text-stone-100 mb-4 sm:mb-6 tracking-wide" style={{
          fontFamily: 'Cinzel, serif'
        }} data-id="element-1608" data-mp="3h27yvv5yc4b7">
            What Does This Look Like When You HAVEN'T Made These Paradigm
            Shifts?
          </h2>

          <h2 className="text-2xl sm:text-4xl md:text-6xl font-serif text-amber-500 leading-tight font-bold" style={{
          fontFamily: 'Cinzel, serif',
          textShadow: '0 0 40px rgba(217, 119, 6, 0.4)'
        }} data-id="element-1609" data-mp="2y9m5dhiiopts">
            {' '}
            <span className="text-red-500 drop-shadow-lg" style={{
            textShadow: '0 0 30px rgba(220, 38, 38, 0.5)'
          }} data-id="element-1610" data-mp="hkqkoflunf2f">
              6 of the Most Common Lies Being Spread About Peptides
            </span>
          </h2>
        </div>

        {/* Sub-headline */}

        {/* Normal text */}
        <div className="space-y-4 sm:space-y-6 text-lg md:text-xl leading-relaxed text-stone-300" data-id="element-1611" data-mp="ywgiqw39jcao">
          <p className="text-stone-100 font-semibold text-base sm:text-lg" data-id="element-1612" data-mp="13u09gvh5dhji">
            See if you've heard people say any of the following...
          </p>
        </div>
      </motion.div>

      {/* NEW SECTION: Classic Misinformation #1 - ENHANCED HEADER */}
      <motion.div ref={ref4} initial={{
      opacity: 0,
      y: 20
    }} animate={inView4 ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.4
    }} className="relative z-10 max-w-4xl mx-auto mt-12 sm:mt-20" data-id="element-1613" data-mp="fynsat9tsuu6">
        {/* Decorative Divider */}
        <div className="flex items-center justify-center gap-4 mb-8 sm:mb-12" data-id="element-1614" data-mp="3oenjz7umm4q">
          <div className="w-full h-px bg-gradient-to-r from-transparent via-amber-600/30 to-transparent" data-id="element-1615" data-mp="3uuphlbefymmk" />
          <div className="w-3 h-3 bg-amber-600 rotate-45 flex-shrink-0" data-id="element-1616" data-mp="dehnkjde10ck" />
          <div className="w-full h-px bg-gradient-to-r from-transparent via-amber-600/30 to-transparent" data-id="element-1617" data-mp="8mzk9onw6nof" />
        </div>

        {/* DRAMATICALLY ENHANCED HEADLINE */}
        <div className="relative mb-8 sm:mb-12" data-id="element-1618" data-mp="mg7e7mzg3v9a">
          {/* Intense glow background */}
          <div className="absolute inset-0 bg-gradient-to-r from-amber-600/20 via-amber-500/30 to-amber-600/20 blur-xl sm:blur-2xl animate-pulse-slow" data-id="element-1619" data-mp="ielupiseoiq4" />

          {/* Main header container */}
          <div className="relative bg-gradient-to-br from-amber-950/60 via-stone-950/80 to-black border-2 sm:border-4 border-amber-600/60 p-5 sm:p-8 md:p-10 shadow-[0_0_16px_rgba(217,119,6,0.26)] sm:shadow-[0_0_60px_rgba(217,119,6,0.5)]" data-id="element-1620" data-mp="re0i29da0d6e">
            {/* Corner accents */}
            <div className="absolute top-0 left-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-1621" data-mp="x2r1x88ifze2">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 to-transparent" data-id="element-1622" data-mp="1200qklo2s70u" />
              <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-amber-500 to-transparent" data-id="element-1623" data-mp="1612p10a64f1r" />
              <div className="absolute top-2 left-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" data-id="element-1624" data-mp="1b205n8fj5115" />
            </div>
            <div className="absolute top-0 right-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-1625" data-mp="1g01phvks54do">
              <div className="absolute top-0 right-0 w-full h-1 bg-gradient-to-l from-amber-500 to-transparent" data-id="element-1626" data-mp="1ky3hj606oe1a" />
              <div className="absolute top-0 right-0 w-1 h-full bg-gradient-to-b from-amber-500 to-transparent" data-id="element-1627" data-mp="1pqmtjyj8313z" />
              <div className="absolute top-2 right-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '0.5s'
            }} data-id="element-1628" data-mp="1ttsxv0mryi7t" />
            </div>
            <div className="absolute bottom-0 left-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-1629" data-mp="2dtjdsc73dwmr">
              <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 to-transparent" data-id="element-1630" data-mp="28uq1gn3jkbo6" />
              <div className="absolute bottom-0 left-0 w-1 h-full bg-gradient-to-t from-amber-500 to-transparent" data-id="element-1631" data-mp="23vddu04uj0kj" />
              <div className="absolute bottom-2 left-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '1s'
            }} data-id="element-1632" data-mp="1zutkz8rb2j47" />
            </div>
            <div className="absolute bottom-0 right-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-1633" data-mp="2rlr7tw6zr9hr">
              <div className="absolute bottom-0 right-0 w-full h-1 bg-gradient-to-l from-amber-500 to-transparent" data-id="element-1634" data-mp="2mt6jvbarnqm5" />
              <div className="absolute bottom-0 right-0 w-1 h-full bg-gradient-to-t from-amber-500 to-transparent" data-id="element-1635" data-mp="2ise6q6yrx1kl" />
              <div className="absolute bottom-2 right-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '1.5s'
            }} data-id="element-1636" data-mp="3fcwq0i0emdv8" />
            </div>

            {/* Icon */}
            <div className="flex justify-center mb-4 sm:mb-6" data-id="element-1637" data-mp="301ydvx3nox1r">
              <div className="relative" data-id="element-1638" data-mp="2m1nm8ruivefj">
                <div className="absolute inset-0 bg-amber-500/40 blur-xl animate-pulse-slow" data-id="element-1639" data-mp="2m2p69ltinb9e" />
                <AlertOctagon className="relative w-10 h-10 sm:w-12 sm:h-12 text-amber-400 drop-shadow-[0_0_15px_rgba(251,191,36,0.8)]" data-id="element-1640" data-mp="2q3r0tpchmz51" />
              </div>
            </div>

            {/* Number badge */}
            <div className="text-center mb-4" data-id="element-1641" data-mp="3ir51nyjb4euf">
              <span className="inline-block px-3 sm:px-6 py-2 bg-amber-600/30 border-2 border-amber-500/50 text-amber-400 font-bold tracking-normal sm:tracking-[0.2em] uppercase text-xs sm:text-lg md:text-xl" style={{
              textShadow: '0 0 20px rgba(251, 191, 36, 0.6)'
            }} data-id="element-1642" data-mp="350hztxi928u4">
                Classic Misinformation Spread In The Peptide World #1
              </span>
            </div>

            {/* Main title */}
            <h4 className="text-2xl sm:text-3xl md:text-5xl font-serif text-center text-amber-100 leading-tight font-bold" style={{
            fontFamily: 'Cinzel, serif',
            textShadow: '0 0 40px rgba(217, 119, 6, 0.8), 0 0 60px rgba(217, 119, 6, 0.4)'
          }} data-id="element-1643" data-mp="1l42grtbtcbdv">
              The "Peptides & Small Molecule Drugs Are the Same" Myth
            </h4>
          </div>
        </div>

        {/* Content Box */}
        <div className="bg-stone-900/40 border border-stone-800 p-6 sm:p-8 md:p-10 rounded-sm relative overflow-hidden" data-id="element-1644" data-mp="1h2h9qolymrbl">
          <div className="absolute top-0 right-0 w-64 h-64 bg-amber-900/10 blur-3xl rounded-full -translate-y-1/2 translate-x-1/2" data-id="element-1645" data-mp="1c2uxoihvbh4d" />

          <div className="space-y-4 sm:space-y-6 text-base sm:text-lg text-stone-300 relative z-10" data-id="element-1646" data-mp="2sgbdq77i68ay">
            <p data-id="element-1647" data-mp="2ni1f1mmkkpkl">
              Have you ever heard of the compound{' '}
              <span className="text-stone-100 font-semibold" data-id="element-1648" data-mp="2umiza5nm63hf">SLU-PP-332</span>?
              Or perhaps{' '}
              <span className="text-stone-100 font-semibold" data-id="element-1649" data-mp="2zjt0eikd83l3">MK-677</span>? How
              about Tesofensine, BAM15 or PEA?
            </p>

            <p className="font-medium text-amber-500/90 italic" data-id="element-1650" data-mp="34huf6rardgqr">
              If you have, here's the question:
            </p>

            <p className="text-lg sm:text-xl text-stone-100 font-bold border-l-4 border-amber-600 pl-4 sm:pl-6 py-2 bg-gradient-to-r from-amber-950/30 to-transparent" data-id="element-1651" data-mp="2bvi13jubibyx">
              Have you heard people call them peptides?
            </p>

            <p data-id="element-1652" data-mp="2lruwcm5igxvs">
              I know of world renowned doctors and influencers with hundreds of
              thousands of followers that continually push this nonsense.
            </p>

            <p data-id="element-1653" data-mp="1t3p7pobc6oqo">I have to wonder if they do it intentionally.</p>

            <p data-id="element-1654" data-mp="1y3lh632sz8dm">
              Because they will often position peptides and bioregulators as
              having "no side effects" (which can be true when they're properly
              classified, for example Khavinson's bioregulators seem to be
              largely side-effect free even up to extreme dosages).
            </p>

            <div className="flex gap-4 items-start bg-red-950/20 p-4 sm:p-6 border border-red-900/30 rounded-sm my-6 sm:my-8" data-id="element-1655" data-mp="66zh0k75wwtv">
              <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-1656" data-mp="18pq4lsh0ie2" />
              <div data-id="element-1657" data-mp="3sg25qwdpgnrv">
                <p className="text-stone-100 font-bold text-base sm:text-lg mb-2" data-id="element-1658" data-mp="3sgk0tpomsvy7">
                  But those compounds are NOT peptides...
                </p>
                <p className="text-red-200/80 text-sm sm:text-base" data-id="element-1659" data-mp="3jm5jziogddcz">
                  ...and they can have{' '}
                  <span className="text-red-400 font-bold uppercase tracking-wide" data-id="element-1660" data-mp="3ep5ep9zfgemx">
                    EXTREME side-effects
                  </span>{' '}
                  when used incorrectly.
                </p>
              </div>
            </div>

            <p className="text-sm sm:text-base text-stone-400 italic pl-4 sm:pl-6 border-l border-stone-700" data-id="element-1661" data-mp="xehlrofso1gb">
              (There is also very minimal human safety data on many of them.
              With many of the dosages being recommended, when properly
              converted for humans, simply being impossible to even be
              effective.)
            </p>

            <p data-id="element-1662" data-mp="shhgvguol4qs">
              But they pass them off as if they're all peptides, and they make
              the compounds look better than they are.
            </p>

            <p className="text-stone-100 font-medium" data-id="element-1663" data-mp="ii8nap3q9s4y">
              Which results in people paying premium prices for inferior
              products, often implementing protocols that can't possibly work at
              the suggested dosages, putting their organs at risk of being
              damaged, and questioning why they aren't getting results.
            </p>
          </div>
        </div>
      </motion.div>

      {/* Classic Misinformation #2 - ENHANCED HEADER */}
      <motion.div ref={ref5} initial={{
      opacity: 0,
      y: 20
    }} animate={inView5 ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.4
    }} className="relative z-10 max-w-4xl mx-auto mt-12 sm:mt-20" data-id="element-1664" data-mp="3c9s34tmzm98s">
        <div className="flex items-center justify-center gap-4 mb-8 sm:mb-12" data-id="element-1665" data-mp="3v8xnbsjw4usb">
          <div className="w-full h-px bg-gradient-to-r from-transparent via-amber-600/30 to-transparent" data-id="element-1666" data-mp="3v6tb8nbu8pgy" />
          <div className="w-3 h-3 bg-amber-600 rotate-45 flex-shrink-0" data-id="element-1667" data-mp="8tlarja0vyfb" />
          <div className="w-full h-px bg-gradient-to-r from-transparent via-amber-600/30 to-transparent" data-id="element-1668" data-mp="8stcu1sydolv" />
        </div>

        <div className="relative mb-8 sm:mb-12" data-id="element-1669" data-mp="3wumw9rz7yjc">
          <div className="absolute inset-0 bg-gradient-to-r from-amber-600/20 via-amber-500/30 to-amber-600/20 blur-xl sm:blur-2xl animate-pulse-slow" data-id="element-1670" data-mp="iskagcct8jq6" />

          <div className="relative bg-gradient-to-br from-amber-950/60 via-stone-950/80 to-black border-2 sm:border-4 border-amber-600/60 p-5 sm:p-8 md:p-10 shadow-[0_0_16px_rgba(217,119,6,0.26)] sm:shadow-[0_0_60px_rgba(217,119,6,0.5)]" data-id="element-1671" data-mp="3rmy63axxbf59">
            <div className="absolute top-0 left-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-1672" data-mp="3hptegvlb6rh2">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 to-transparent" data-id="element-1673" data-mp="3mnbsh0e6nwvx" />
              <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-amber-500 to-transparent" data-id="element-1674" data-mp="e7ryfz5ouaft" />
              <div className="absolute top-2 left-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" data-id="element-1675" data-mp="j5tkmsyeupvi" />
            </div>
            <div className="absolute top-0 right-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-1676" data-mp="573mrb3rom63">
              <div className="absolute top-0 right-0 w-full h-1 bg-gradient-to-l from-amber-500 to-transparent" data-id="element-1677" data-mp="97x75ui03iu8" />
              <div className="absolute top-0 right-0 w-1 h-full bg-gradient-to-b from-amber-500 to-transparent" data-id="element-1678" data-mp="2pw158b31u67g" />
              <div className="absolute top-2 right-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '0.5s'
            }} data-id="element-1679" data-mp="2u0ijxvujxtbd" />
            </div>
            <div className="absolute bottom-0 left-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-1680" data-mp="2wdkpl0d0sykg">
              <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 to-transparent" data-id="element-1681" data-mp="2wbi2ao395jjf" />
              <div className="absolute bottom-0 left-0 w-1 h-full bg-gradient-to-t from-amber-500 to-transparent" data-id="element-1682" data-mp="23oxc3qyijdhg" />
              <div className="absolute bottom-2 left-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '1s'
            }} data-id="element-1683" data-mp="1yqm0baonqswl" />
            </div>
            <div className="absolute bottom-0 right-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-1684" data-mp="28mp56oaw95n8">
              <div className="absolute bottom-0 right-0 w-full h-1 bg-gradient-to-l from-amber-500 to-transparent" data-id="element-1685" data-mp="1kxnsgov138c5" />
              <div className="absolute bottom-0 right-0 w-1 h-full bg-gradient-to-t from-amber-500 to-transparent" data-id="element-1686" data-mp="1fz2znai3vqxq" />
              <div className="absolute bottom-2 right-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '1.5s'
            }} data-id="element-1687" data-mp="25lnmknxhpyga" />
            </div>

            <div className="flex justify-center mb-4 sm:mb-6" data-id="element-1688" data-mp="2jfobkpyn473g">
              <div className="relative" data-id="element-1689" data-mp="2jh94kb5b3hz7">
                <div className="absolute inset-0 bg-amber-500/40 blur-xl animate-pulse-slow" data-id="element-1690" data-mp="1mpe2njzwqdod" />
                <AlertOctagon className="relative w-10 h-10 sm:w-12 sm:h-12 text-amber-400 drop-shadow-[0_0_15px_rgba(251,191,36,0.8)]" data-id="element-1691" data-mp="1qpxwoep6p16a" />
              </div>
            </div>

            <div className="text-center mb-4" data-id="element-1692" data-mp="20oney8kzsnn2">
              <span className="inline-block px-3 sm:px-6 py-2 bg-amber-600/30 border-2 border-amber-500/50 text-amber-400 font-bold tracking-normal sm:tracking-[0.2em] uppercase text-xs sm:text-lg md:text-xl" style={{
              textShadow: '0 0 20px rgba(251, 191, 36, 0.6)'
            }} data-id="element-1693" data-mp="20pgdim9ss6u4">
                Classic Misinformation Spread In The Peptide World #2
              </span>
            </div>

            <h4 className="text-2xl sm:text-3xl md:text-5xl font-serif text-center text-amber-100 leading-tight font-bold" style={{
            fontFamily: 'Cinzel, serif',
            textShadow: '0 0 40px rgba(217, 119, 6, 0.8), 0 0 60px rgba(217, 119, 6, 0.4)'
          }} data-id="element-1694" data-mp="qqdxekwg9ub5">
              The "Peptides Don't Work Orally" Fallacy
            </h4>
          </div>
        </div>

        {/* Content Box */}
        <div className="bg-stone-900/40 border border-stone-800 p-6 sm:p-8 md:p-10 rounded-sm relative overflow-hidden" data-id="element-1695" data-mp="7tmi0mk13zcd">
          <div className="absolute top-0 left-0 w-64 h-64 bg-amber-900/10 blur-3xl rounded-full -translate-y-1/2 -translate-x-1/2" data-id="element-1696" data-mp="225kdllpf0wps" />

          <div className="space-y-4 sm:space-y-6 text-base sm:text-lg text-stone-300 relative z-10" data-id="element-1697" data-mp="1x7slorortall">
            <p data-id="element-1698" data-mp="258qlh0wljlwd">
              Here's how you instantly identify someone who doesn't actually
              understand peptides:
            </p>

            <p className="text-lg sm:text-xl text-stone-100 font-bold border-l-4 border-amber-600 pl-4 sm:pl-6 py-2 bg-gradient-to-r from-amber-950/30 to-transparent" data-id="element-1699" data-mp="2a45t3b40glkc">
              They say "peptides don't work orally."
            </p>

            <p data-id="element-1700" data-mp="1mgnx13dpr1bk">
              There are multiple doctors out there spreading this idea with
              confidence.
            </p>

            <div className="flex gap-4 items-start bg-red-950/20 p-4 sm:p-6 border border-red-900/30 rounded-sm my-6 sm:my-8" data-id="element-1701" data-mp="1r8yywbs0kx6r">
              <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-1702" data-mp="1hhulhghzlke1" />
              <div data-id="element-1703" data-mp="1hfqj52zqktfv">
                <p className="text-stone-100 font-bold text-base sm:text-lg mb-2" data-id="element-1704" data-mp="13i1x3rtxng98">
                  But it's COMPLETELY wrong.
                </p>
              </div>
            </div>

            <div className="flex gap-4 items-start bg-green-950/20 p-4 sm:p-6 border border-green-900/30 rounded-sm my-6 sm:my-8" data-id="element-1705" data-mp="17lrn8lq9a5wd">
              <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" data-id="element-1706" data-mp="jwtd7u0qjzcl" />
              <div data-id="element-1707" data-mp="xw1gay00rrm2">
                <p className="text-stone-100 font-bold text-base sm:text-lg mb-2" data-id="element-1708" data-mp="xwknpks1mxlu">
                  The truth:
                </p>
                <p className="text-green-200/80 text-sm sm:text-base" data-id="element-1709" data-mp="sverhcz6cs7k">
                  Many peptides{' '}
                  <span className="text-green-400 font-bold uppercase tracking-wide" data-id="element-1710" data-mp="17se79o46jrd4">
                    DO work orally
                  </span>
                  . But many peptides also do NOT work orally. It's not black &
                  white.
                </p>
              </div>
            </div>

            <p data-id="element-1711" data-mp="1clqrzn5qne0l">
              The key is understanding the specific characteristics that
              determine oral bioavailability, and ultimately knowing which ones
              will work compared to which ones won't.
            </p>

            <p data-id="element-1712" data-mp="j8haobppifly">
              When someone makes blanket statements about oral peptides, they're
              showing you they don't understand the biological mechanisms behind
              how they work.
            </p>

            <p className="text-stone-100 font-medium italic border-l border-stone-700 pl-4 sm:pl-6 text-sm sm:text-base" data-id="element-1713" data-mp="s7uo1fgyboby">
              They're regurgitating oversimplified "rules" instead of operating
              from mechanistic understanding.
            </p>
          </div>
        </div>
      </motion.div>

      {/* Classic Misinformation #3 - ENHANCED HEADER */}
      <motion.div ref={ref6} initial={{
      opacity: 0,
      y: 20
    }} animate={inView6 ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.4
    }} className="relative z-10 max-w-4xl mx-auto mt-12 sm:mt-20" data-id="element-1714" data-mp="1azn82ke1lz7j">
        <div className="flex items-center justify-center gap-4 mb-8 sm:mb-12" data-id="element-1715" data-mp="3a6c1h8zaafzt">
          <div className="w-full h-px bg-gradient-to-r from-transparent via-amber-600/30 to-transparent" data-id="element-1716" data-mp="3a8f18kq8nnhq" />
          <div className="w-3 h-3 bg-amber-600 rotate-45 flex-shrink-0" data-id="element-1717" data-mp="35dj08v30xpsh" />
          <div className="w-full h-px bg-gradient-to-r from-transparent via-amber-600/30 to-transparent" data-id="element-1718" data-mp="30h27tooskp9l" />
        </div>

        <div className="relative mb-8 sm:mb-12" data-id="element-1719" data-mp="2vfcycdh7wjnm">
          <div className="absolute inset-0 bg-gradient-to-r from-amber-600/20 via-amber-500/30 to-amber-600/20 blur-xl sm:blur-2xl animate-pulse-slow" data-id="element-1720" data-mp="3t5g9qfj045qf" />

          <div className="relative bg-gradient-to-br from-amber-950/60 via-stone-950/80 to-black border-2 sm:border-4 border-amber-600/60 p-5 sm:p-8 md:p-10 shadow-[0_0_16px_rgba(217,119,6,0.26)] sm:shadow-[0_0_60px_rgba(217,119,6,0.5)]" data-id="element-1721" data-mp="3o4af2c5s68e9">
            <div className="absolute top-0 left-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-1722" data-mp="27s3paqgrbl3r">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 to-transparent" data-id="element-1723" data-mp="23qi4mixze2j0" />
              <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-amber-500 to-transparent" data-id="element-1724" data-mp="6p47d8dsah97" />
              <div className="absolute top-2 left-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" data-id="element-1725" data-mp="boywp7hwuys5" />
            </div>
            <div className="absolute top-0 right-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-1726" data-mp="3tvn0mu185fw8">
              <div className="absolute top-0 right-0 w-full h-1 bg-gradient-to-l from-amber-500 to-transparent" data-id="element-1727" data-mp="2n8ynitix1le" />
              <div className="absolute top-0 right-0 w-1 h-full bg-gradient-to-b from-amber-500 to-transparent" data-id="element-1728" data-mp="qewg7a4wb0b0" />
              <div className="absolute top-2 right-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '0.5s'
            }} data-id="element-1729" data-mp="ueov04kvu2ot" />
            </div>
            <div className="absolute bottom-0 left-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-1730" data-mp="19ch70mr808y9">
              <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 to-transparent" data-id="element-1731" data-mp="19ae5p6kmate8" />
              <div className="absolute bottom-0 left-0 w-1 h-full bg-gradient-to-t from-amber-500 to-transparent" data-id="element-1732" data-mp="1e50h39qp8lyb" />
              <div className="absolute bottom-2 left-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '1s'
            }} data-id="element-1733" data-mp="1jgnrfd0vyqoz" />
            </div>
            <div className="absolute bottom-0 right-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-1734" data-mp="1sa0uh7snz8os">
              <div className="absolute bottom-0 right-0 w-full h-1 bg-gradient-to-l from-amber-500 to-transparent" data-id="element-1735" data-mp="14idbrd5k33xl" />
              <div className="absolute bottom-0 right-0 w-1 h-full bg-gradient-to-t from-amber-500 to-transparent" data-id="element-1736" data-mp="10iv25dj6qfa2" />
              <div className="absolute bottom-2 right-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '1.5s'
            }} data-id="element-1737" data-mp="1eivzij08r4ks" />
            </div>

            <div className="flex justify-center mb-4 sm:mb-6" data-id="element-1738" data-mp="2kxdf3cf9l6fg">
              <div className="relative" data-id="element-1739" data-mp="2kx54xsaj0f7y">
                <div className="absolute inset-0 bg-amber-500/40 blur-xl animate-pulse-slow" data-id="element-1740" data-mp="dsfsdmmewoyi" />
                <AlertOctagon className="relative w-10 h-10 sm:w-12 sm:h-12 text-amber-400 drop-shadow-[0_0_15px_rgba(251,191,36,0.8)]" data-id="element-1741" data-mp="8tupfffrzr6d" />
              </div>
            </div>

            <div className="text-center mb-4" data-id="element-1742" data-mp="4u3tkxbe6kuz">
              <span className="inline-block px-3 sm:px-6 py-2 bg-amber-600/30 border-2 border-amber-500/50 text-amber-400 font-bold tracking-normal sm:tracking-[0.2em] uppercase text-xs sm:text-lg md:text-xl" style={{
              textShadow: '0 0 20px rgba(251, 191, 36, 0.6)'
            }} data-id="element-1743" data-mp="3vz2i1a52hy6i">
                Classic Misinformation Spread In The Peptide World #3
              </span>
            </div>

            <h4 className="text-2xl sm:text-3xl md:text-5xl font-serif text-center text-amber-100 leading-tight font-bold" style={{
            fontFamily: 'Cinzel, serif',
            textShadow: '0 0 40px rgba(217, 119, 6, 0.8), 0 0 60px rgba(217, 119, 6, 0.4)'
          }} data-id="element-1744" data-mp="ipxyl591oq2t">
              The Timing Protocol That's Destroying Your Absorption
            </h4>
          </div>
        </div>

        {/* Content Box */}
        <div className="bg-stone-900/40 border border-stone-800 p-6 sm:p-8 md:p-10 rounded-sm relative overflow-hidden" data-id="element-1745" data-mp="1ss4tsz1ebir8">
          <div className="absolute top-0 right-0 w-64 h-64 bg-amber-900/10 blur-3xl rounded-full -translate-y-1/2 translate-x-1/2" data-id="element-1746" data-mp="21qq7afs0g7l5" />

          <div className="space-y-4 sm:space-y-6 text-base sm:text-lg text-stone-300 relative z-10" data-id="element-1747" data-mp="26oi2binyc9tk">
            <p data-id="element-1748" data-mp="2bhkwnt0jznat">
              Even the official manufacturer's recommendations for when to take
              peptide capsules are actually harmful for absorption.
            </p>

            <p className="text-lg sm:text-xl text-stone-100 font-bold border-l-4 border-amber-600 pl-4 sm:pl-6 py-2 bg-gradient-to-r from-amber-950/30 to-transparent" data-id="element-1749" data-mp="2khpt5847l1a7">
              The standard advice of "take with food" is NOT based on
              bioavailability or effectiveness.
            </p>

            <div className="flex gap-4 items-start bg-amber-950/20 p-4 sm:p-6 border border-amber-900/30 rounded-sm my-6 sm:my-8" data-id="element-1750" data-mp="lczjr1yp54d7">
              <Clock className="w-6 h-6 text-amber-500 flex-shrink-0 mt-1" data-id="element-1751" data-mp="z4w5mo9rui15" />
              <div data-id="element-1752" data-mp="ubtioyzi26tx">
                <p className="text-stone-100 font-bold text-base sm:text-lg mb-2" data-id="element-1753" data-mp="ubjthdma43pa">
                  The reality:
                </p>
                <p className="text-amber-200/80 text-sm sm:text-base" data-id="element-1754" data-mp="142o7ob44rkj2">
                  Taking oral peptides with food (particularly protein) is going
                  to{' '}
                  <span className="text-red-400 font-bold uppercase tracking-wide" data-id="element-1755" data-mp="1i0crdfmgolmj">
                    reduce its effectiveness
                  </span>
                  .
                </p>
              </div>
            </div>

            <p data-id="element-1756" data-mp="3euz62oiwuhjg">
              In fact, Brenden Henry specifically recommends taking orally
              bioavailable peptides on an{' '}
              <span className="text-stone-100 font-bold uppercase" data-id="element-1757" data-mp="1udzpisf4jt7a">
                EMPTY STOMACH
              </span>{' '}
              (the exact opposite of most recommendations) for maximum
              absorption.
            </p>

            <p className="pl-4 sm:pl-6 border-l-2 border-amber-600/30 text-sm sm:text-base" data-id="element-1758" data-mp="1lijzynlek07i">
              <span className="text-amber-500 font-bold" data-id="element-1759" data-mp="1pjlr0h5615ye">Why?</span> Because
              when proteins are in your stomach, they will compete with peptides
              for absorption via LAT and PEPT transporters.
            </p>

            <p data-id="element-1760" data-mp="12m0m5kznlo4m">
              The official dosing information on many boxes is simply not
              optimal.
            </p>

            <p data-id="element-1761" data-mp="16nvpev15abl1">
              And for the "experts" who DO know you can dose peptides orally,
              they're just parroting advice that's literally reducing the
              effectiveness of your protocols.
            </p>

            <p className="text-stone-100 font-medium italic border-l border-stone-700 pl-4 sm:pl-6 text-sm sm:text-base" data-id="element-1762" data-mp="30z0w687j344l">
              But you have no way of knowing this unless you've studied the
              original absorption kinetics research.
            </p>

            <p className="text-lg sm:text-xl text-stone-100 font-bold" data-id="element-1763" data-mp="22b016tosx6kz">
              Brenden has. You haven't. Neither has anyone else teaching
              peptides online.
            </p>
          </div>
        </div>
      </motion.div>

      {/* Classic Misinformation #4 - ENHANCED HEADER */}
      <motion.div ref={ref7} initial={{
      opacity: 0,
      y: 20
    }} animate={inView7 ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.4
    }} className="relative z-10 max-w-4xl mx-auto mt-12 sm:mt-20" data-id="element-1764" data-mp="1ok4rjf6halgc">
        <div className="flex items-center justify-center gap-4 mb-8 sm:mb-12" data-id="element-1765" data-mp="15n3jtmlji78p">
          <div className="w-full h-px bg-gradient-to-r from-transparent via-amber-600/30 to-transparent" data-id="element-1766" data-mp="3h9x9r31kogr4" />
          <div className="w-3 h-3 bg-amber-600 rotate-45 flex-shrink-0" data-id="element-1767" data-mp="3la7rte2n2xmc" />
          <div className="w-full h-px bg-gradient-to-r from-transparent via-amber-600/30 to-transparent" data-id="element-1768" data-mp="3qa2hjeaohh5t" />
        </div>

        <div className="relative mb-8 sm:mb-12" data-id="element-1769" data-mp="3v9ournqiaxem">
          <div className="absolute inset-0 bg-gradient-to-r from-amber-600/20 via-amber-500/30 to-amber-600/20 blur-xl sm:blur-2xl animate-pulse-slow" data-id="element-1770" data-mp="3v8dpfjhexhle" />

          <div className="relative bg-gradient-to-br from-amber-950/60 via-stone-950/80 to-black border-2 sm:border-4 border-amber-600/60 p-5 sm:p-8 md:p-10 shadow-[0_0_16px_rgba(217,119,6,0.26)] sm:shadow-[0_0_60px_rgba(217,119,6,0.5)]" data-id="element-1771" data-mp="32jq2zkkxgm69">
            <div className="absolute top-0 left-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-1772" data-mp="3cbm28yyr2ic2">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 to-transparent" data-id="element-1773" data-mp="2eu430uwqe2x7" />
              <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-amber-500 to-transparent" data-id="element-1774" data-mp="2jsfefa2oclhj" />
              <div className="absolute top-2 left-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" data-id="element-1775" data-mp="2br7ptglji92n" />
            </div>
            <div className="absolute top-0 right-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-1776" data-mp="27pw61rpcki2d">
              <div className="absolute top-0 right-0 w-full h-1 bg-gradient-to-l from-amber-500 to-transparent" data-id="element-1777" data-mp="2lic2g9nqthub" />
              <div className="absolute top-0 right-0 w-1 h-full bg-gradient-to-b from-amber-500 to-transparent" data-id="element-1778" data-mp="2gmdakc37hhp5" />
              <div className="absolute top-2 right-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '0.5s'
            }} data-id="element-1779" data-mp="1osushihq99mt" />
            </div>
            <div className="absolute bottom-0 left-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-1780" data-mp="1xshrxyqwc5d8">
              <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 to-transparent" data-id="element-1781" data-mp="3e79liezs3io4" />
              <div className="absolute bottom-0 left-0 w-1 h-full bg-gradient-to-t from-amber-500 to-transparent" data-id="element-1782" data-mp="397mwz9ei2g00" />
              <div className="absolute bottom-2 left-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '1s'
            }} data-id="element-1783" data-mp="v05m0jicrulm" />
            </div>
            <div className="absolute bottom-0 right-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-1784" data-mp="m2lggydgjc57">
              <div className="absolute bottom-0 right-0 w-full h-1 bg-gradient-to-l from-amber-500 to-transparent" data-id="element-1785" data-mp="qzlm586eacvs" />
              <div className="absolute bottom-0 right-0 w-1 h-full bg-gradient-to-t from-amber-500 to-transparent" data-id="element-1786" data-mp="1eraa6cc6of6x" />
              <div className="absolute bottom-2 right-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '1.5s'
            }} data-id="element-1787" data-mp="14zcwmyxpdb51" />
            </div>

            <div className="flex justify-center mb-4 sm:mb-6" data-id="element-1788" data-mp="1xmqv51h1uer9">
              <div className="relative" data-id="element-1789" data-mp="22e8ob3ctzb1o">
                <div className="absolute inset-0 bg-amber-500/40 blur-xl animate-pulse-slow" data-id="element-1790" data-mp="22faao3zarjyp" />
                <AlertOctagon className="relative w-10 h-10 sm:w-12 sm:h-12 text-amber-400 drop-shadow-[0_0_15px_rgba(251,191,36,0.8)]" data-id="element-1791" data-mp="2d11gik6rlgt" />
              </div>
            </div>

            <div className="text-center mb-4" data-id="element-1792" data-mp="3oraj88tm1v8m">
              <span className="inline-block px-3 sm:px-6 py-2 bg-amber-600/30 border-2 border-amber-500/50 text-amber-400 font-bold tracking-normal sm:tracking-[0.2em] uppercase text-xs sm:text-lg md:text-xl" style={{
              textShadow: '0 0 20px rgba(251, 191, 36, 0.6)'
            }} data-id="element-1793" data-mp="3os3o1490eao4">
                Classic Misinformation Spread In The Peptide World #4
              </span>
            </div>

            <h4 className="text-2xl sm:text-3xl md:text-5xl font-serif text-center text-amber-100 leading-tight font-bold" style={{
            fontFamily: 'Cinzel, serif',
            textShadow: '0 0 40px rgba(217, 119, 6, 0.8), 0 0 60px rgba(217, 119, 6, 0.4)'
          }} data-id="element-1794" data-mp="7c3x5cea0fc4">
              The False "BPC-157 Is the Best Healing Peptide" Narrative
            </h4>
          </div>
        </div>

        {/* Content Box */}
        <div className="bg-stone-900/40 border border-stone-800 p-6 sm:p-8 md:p-10 rounded-sm relative overflow-hidden" data-id="element-1795" data-mp="1gjyoik3zkdxf">
          <div className="absolute top-0 left-0 w-64 h-64 bg-amber-900/10 blur-3xl rounded-full -translate-y-1/2 -translate-x-1/2" data-id="element-1796" data-mp="1lbp3529yhnun" />

          <div className="space-y-4 sm:space-y-6 text-base sm:text-lg text-stone-300 relative z-10" data-id="element-1797" data-mp="1qcctdlqd20nt">
            <p data-id="element-1798" data-mp="1vaxxhw8qh4hj">
              Here's something that will shock most people in the peptide
              community:
            </p>

            <p className="text-lg sm:text-xl text-stone-100 font-bold border-l-4 border-amber-600 pl-4 sm:pl-6 py-2 bg-gradient-to-r from-amber-950/30 to-transparent" data-id="element-1799" data-mp="24a1g6z3znhvi">
              We do NOT generally recommend BPC-157 for healing.
            </p>

            <p data-id="element-1800" data-mp="9xus4zpzx6ls">Not because it doesn't work.</p>

            <p data-id="element-1801" data-mp="3pv7ejt7mvrfn">
              But because there's a{' '}
              <span className="text-amber-500 font-bold" data-id="element-1802" data-mp="3psbjqdr31ivf">
                vastly superior, yet basically unknown peptide
              </span>{' '}
              we recommend instead for most healing protocols.
            </p>

            <div className="bg-stone-950/50 p-4 sm:p-6 border border-stone-800 rounded-sm my-6 sm:my-8" data-id="element-1803" data-mp="8do9cgat1v4i">
              <p className="text-stone-100 font-bold mb-4 flex items-center gap-2 text-base sm:text-lg" data-id="element-1804" data-mp="cg1bkuqcfawj">
                <CheckCircle className="w-5 h-5 text-green-500" data-id="element-1805" data-mp="hdtf6m0colgk" />
                This superior peptide has:
              </p>
              <ul className="space-y-3 text-sm sm:text-base" data-id="element-1806" data-mp="mf0m6iuo5gm6">
                <li className="flex items-start gap-3" data-id="element-1807" data-mp="rdbwsvssfv5g">
                  <div className="w-1.5 h-1.5 bg-amber-500 rounded-full mt-2.5 flex-shrink-0" data-id="element-1808" data-mp="rc0r2qfs8dbp" />
                  <span data-id="element-1809" data-mp="2o6wwjp53okfd">Better tissue regeneration properties</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1810" data-mp="2t4oylbzglmxa">
                  <div className="w-1.5 h-1.5 bg-amber-500 rounded-full mt-2.5 flex-shrink-0" data-id="element-1811" data-mp="1a9kifmkcjx7i" />
                  <span data-id="element-1812" data-mp="15hsp549t3ddo">Fewer side effect risks</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1813" data-mp="15ghjt00ppxkg">
                  <div className="w-1.5 h-1.5 bg-amber-500 rounded-full mt-2.5 flex-shrink-0" data-id="element-1814" data-mp="11hijxttu8qzv" />
                  <span data-id="element-1815" data-mp="wixixs6ri3ad">More comprehensive healing mechanisms</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1816" data-mp="1t86h6use5c89">
                  <div className="w-1.5 h-1.5 bg-amber-500 rounded-full mt-2.5 flex-shrink-0" data-id="element-1817" data-mp="1t5kcr40srcu9" />
                  <span data-id="element-1818" data-mp="1p4gz8o681sw7">FAR MORE research and safety data in humans</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1819" data-mp="1k9ba7ghivy3w">
                  <div className="w-1.5 h-1.5 bg-amber-500 rounded-full mt-2.5 flex-shrink-0" data-id="element-1820" data-mp="1f72jyrw1ba5h" />
                  <span data-id="element-1821" data-mp="8t35p9ij6cpl">
                    Can be taken even in extremely high dosages with basically
                    NO negative effects seen
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1822" data-mp="59vxlobul5fa">
                  <div className="w-1.5 h-1.5 bg-amber-500 rounded-full mt-2.5 flex-shrink-0" data-id="element-1823" data-mp="58b84d4e4coa" />
                  <span data-id="element-1824" data-mp="a6us47zfbee0">
                    The ability to enhance your biological function at the DNA
                    level
                  </span>
                </li>
              </ul>
            </div>

            <p data-id="element-1825" data-mp="3ip0qkzzij084">
              But almost nobody knows about it because they're stuck in the
              BPC-157 echo chamber.
            </p>

            <p data-id="element-1826" data-mp="3ngirxp5g72tm">
              Influencers teach BPC-157 because it's what everyone else teaches.
            </p>

            <p data-id="element-1827" data-mp="39px73uwfoit3">
              Practitioners recommend BPC-157 because it's what they learned
              from those influencers.
            </p>

            <div className="flex gap-4 items-start bg-red-950/20 p-4 sm:p-6 border border-red-900/30 rounded-sm my-6 sm:my-8" data-id="element-1828" data-mp="2zqg45l8kgj0t">
              <ShieldAlert className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-1829" data-mp="34o7tq8lqnt1u" />
              <div data-id="element-1830" data-mp="2l2xu07c8iw70">
                <p className="text-red-200/80 text-sm sm:text-base" data-id="element-1831" data-mp="2l4ira4pxot8k">
                  Meanwhile, you're using a second-tier healing peptide with the
                  potential for some{' '}
                  <span className="text-red-400 font-bold uppercase tracking-wide" data-id="element-1832" data-mp="2v2oo47wvv96k">
                    harrowing side-effects
                  </span>{' '}
                  (like anhedonia) when a superior option exists.
                </p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Classic Misinformation #5 - ENHANCED HEADER */}
      <motion.div ref={ref8} initial={{
      opacity: 0,
      y: 20
    }} animate={inView8 ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.4
    }} className="relative z-10 max-w-4xl mx-auto mt-12 sm:mt-20" data-id="element-1833" data-mp="3dso8wiloy246">
        <div className="flex items-center justify-center gap-4 mb-8 sm:mb-12" data-id="element-1834" data-mp="1g4u6g6hfq1gc">
          <div className="w-full h-px bg-gradient-to-r from-transparent via-amber-600/30 to-transparent" data-id="element-1835" data-mp="1g2q4hu33jcip" />
          <div className="w-3 h-3 bg-amber-600 rotate-45 flex-shrink-0" data-id="element-1836" data-mp="1pudqhfgvw1cs" />
          <div className="w-full h-px bg-gradient-to-r from-transparent via-amber-600/30 to-transparent" data-id="element-1837" data-mp="1pv5lao2npv20" />
        </div>

        <div className="relative mb-8 sm:mb-12" data-id="element-1838" data-mp="1uv9xi1wj83mf">
          <div className="absolute inset-0 bg-gradient-to-r from-amber-600/20 via-amber-500/30 to-amber-600/20 blur-xl sm:blur-2xl animate-pulse-slow" data-id="element-1839" data-mp="x702i6v5yg4t" />

          <div className="relative bg-gradient-to-br from-amber-950/60 via-stone-950/80 to-black border-2 sm:border-4 border-amber-600/60 p-5 sm:p-8 md:p-10 shadow-[0_0_16px_rgba(217,119,6,0.26)] sm:shadow-[0_0_60px_rgba(217,119,6,0.5)]" data-id="element-1840" data-mp="173w37qetlxyt">
            <div className="absolute top-0 left-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-1841" data-mp="2ihzw0t9o9g2a">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 to-transparent" data-id="element-1842" data-mp="2mk3i0btyw31t" />
              <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-amber-500 to-transparent" data-id="element-1843" data-mp="axjanxwngyf2" />
              <div className="absolute top-2 left-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" data-id="element-1844" data-mp="6wzbypwfhmqt" />
            </div>
            <div className="absolute top-0 right-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-1845" data-mp="234ult4apjuw">
              <div className="absolute top-0 right-0 w-full h-1 bg-gradient-to-l from-amber-500 to-transparent" data-id="element-1846" data-mp="3ta7j2csr1c1f" />
              <div className="absolute top-0 right-0 w-1 h-full bg-gradient-to-b from-amber-500 to-transparent" data-id="element-1847" data-mp="3odqwvo5417qz" />
              <div className="absolute top-2 right-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '0.5s'
            }} data-id="element-1848" data-mp="3jbrw8m0r8oxq" />
            </div>
            <div className="absolute bottom-0 left-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-1849" data-mp="1djus8nunl3cw">
              <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 to-transparent" data-id="element-1850" data-mp="1dhs4ybkvxobv" />
              <div className="absolute bottom-0 left-0 w-1 h-full bg-gradient-to-t from-amber-500 to-transparent" data-id="element-1851" data-mp="1rpwtxs2na931" />
              <div className="absolute bottom-2 left-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '1s'
            }} data-id="element-1852" data-mp="1wgwlsiwwq0yo" />
            </div>
            <div className="absolute bottom-0 right-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-1853" data-mp="1nokyh5x3atmx">
              <div className="absolute bottom-0 right-0 w-full h-1 bg-gradient-to-l from-amber-500 to-transparent" data-id="element-1854" data-mp="2bep41itu93gk" />
              <div className="absolute bottom-0 right-0 w-1 h-full bg-gradient-to-t from-amber-500 to-transparent" data-id="element-1855" data-mp="2fepi32d0zcn3" />
              <div className="absolute bottom-2 right-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '1.5s'
            }} data-id="element-1856" data-mp="21hkf5b8lytw2" />
            </div>

            <div className="flex justify-center mb-4 sm:mb-6" data-id="element-1857" data-mp="uzx8wy5b5i3k">
              <div className="relative" data-id="element-1858" data-mp="uxb3b41z9cnz">
                <div className="absolute inset-0 bg-amber-500/40 blur-xl animate-pulse-slow" data-id="element-1859" data-mp="nfd53vp8xo02" />
                <AlertOctagon className="relative w-10 h-10 sm:w-12 sm:h-12 text-amber-400 drop-shadow-[0_0_15px_rgba(251,191,36,0.8)]" data-id="element-1860" data-mp="ihbfst188sg5" />
              </div>
            </div>

            <div className="text-center mb-4" data-id="element-1861" data-mp="rhgmf0yljmt9">
              <span className="inline-block px-3 sm:px-6 py-2 bg-amber-600/30 border-2 border-amber-500/50 text-amber-400 font-bold tracking-normal sm:tracking-[0.2em] uppercase text-xs sm:text-lg md:text-xl" style={{
              textShadow: '0 0 20px rgba(251, 191, 36, 0.6)'
            }} data-id="element-1862" data-mp="rirpeyk7wqjb">
                Classic Misinformation Spread In The Peptide World #5
              </span>
            </div>

            <h4 className="text-2xl sm:text-3xl md:text-5xl font-serif text-center text-amber-100 leading-tight font-bold" style={{
            fontFamily: 'Cinzel, serif',
            textShadow: '0 0 40px rgba(217, 119, 6, 0.8), 0 0 60px rgba(217, 119, 6, 0.4)'
          }} data-id="element-1863" data-mp="3h6ilrs2p83ld">
              The Growth Hormone Releasing Peptide Paradox
            </h4>
          </div>
        </div>

        {/* Content Box */}
        <div className="bg-stone-900/40 border border-stone-800 p-6 sm:p-8 md:p-10 rounded-sm relative overflow-hidden" data-id="element-1864" data-mp="30ownnuxoizt4">
          <div className="absolute top-0 right-0 w-64 h-64 bg-amber-900/10 blur-3xl rounded-full -translate-y-1/2 translate-x-1/2" data-id="element-1865" data-mp="3akztbarqpgkt" />

          <div className="space-y-4 sm:space-y-6 text-base sm:text-lg text-stone-300 relative z-10" data-id="element-1866" data-mp="3el0fjhl2yw2f">
            <p data-id="element-1867" data-mp="3jecqiowu74cp">
              This is the one that proves beyond doubt how surface-level most
              "expert" knowledge is:
            </p>

            <p className="text-lg sm:text-xl text-stone-100 font-bold border-l-4 border-amber-600 pl-4 sm:pl-6 py-2 bg-gradient-to-r from-amber-950/30 to-transparent" data-id="element-1868" data-mp="3tb7qlc8rdct3">
              Growth Hormone Releasing Peptides like sermorelin, ipamorelin and
              CJC-1295 might be the WORST choice if you want to increase growth
              hormone levels.
            </p>

            <p className="font-bold text-amber-500 italic" data-id="element-1869" data-mp="1hpysverkia5d">Read that again.</p>

            <p data-id="element-1870" data-mp="1cpb2mvb5xxc7">
              The peptides specifically marketed for increasing growth hormone
              might be the worst option for that goal.
            </p>

            <p data-id="element-1871" data-mp="25dq40f1dgh52">
              <span className="text-stone-100 font-bold" data-id="element-1872" data-mp="25cf3qp74xrip">Why?</span>
            </p>

            <div className="flex gap-4 items-start bg-red-950/20 p-4 sm:p-6 border border-red-900/30 rounded-sm my-6 sm:my-8" data-id="element-1873" data-mp="20e3pm29t4uuo">
              <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-1874" data-mp="1vm2i0tnl3saz" />
              <div data-id="element-1875" data-mp="1qnivar162chk">
                <p className="text-red-200/80 text-sm sm:text-base" data-id="element-1876" data-mp="1qo0zqaxzfx0k">
                  Because every single one of these options brings a whole host
                  of potential risks, side-effects and extra responsibilities to
                  make sure you do it properly...
                </p>
                <p className="text-stone-100 font-bold mt-2 text-base sm:text-lg" data-id="element-1877" data-mp="3l2n00uuqdwqs">
                  While resulting in WORSE effects than the superior option.
                </p>
              </div>
            </div>

            <p data-id="element-1878" data-mp="3u0owcx3is17q">
              Yet these are ultimately the most well-known options in the
              peptide world when it comes to increasing growth hormone levels.
            </p>

            <p className="text-stone-100 font-medium italic border-l border-stone-700 pl-4 sm:pl-6 text-sm sm:text-base" data-id="element-1879" data-mp="7u0cflhgl0uh">
              Unless you understand these mechanisms at the molecular level,
              you're implementing protocols that sound right but deliver
              suboptimal results.
            </p>
          </div>
        </div>
      </motion.div>

      {/* Classic Misinformation #6 - ENHANCED HEADER */}
      <motion.div ref={ref9} initial={{
      opacity: 0,
      y: 20
    }} animate={inView9 ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.4
    }} className="relative z-10 max-w-4xl mx-auto mt-12 sm:mt-20" data-id="element-1880" data-mp="qjq6g6dedilc">
        <div className="flex items-center justify-center gap-4 mb-8 sm:mb-12" data-id="element-1881" data-mp="wa67owver376">
          <div className="w-full h-px bg-gradient-to-r from-transparent via-amber-600/30 to-transparent" data-id="element-1882" data-mp="1083vbv9j5h8g" />
          <div className="w-3 h-3 bg-amber-600 rotate-45 flex-shrink-0" data-id="element-1883" data-mp="mgz49hk89x9q" />
          <div className="w-full h-px bg-gradient-to-r from-transparent via-amber-600/30 to-transparent" data-id="element-1884" data-mp="ra1ylrwtxaqz" />
        </div>

        <div className="relative mb-8 sm:mb-12" data-id="element-1885" data-mp="cloz4kyj99rq">
          <div className="absolute inset-0 bg-gradient-to-r from-amber-600/20 via-amber-500/30 to-amber-600/20 blur-xl sm:blur-2xl animate-pulse-slow" data-id="element-1886" data-mp="hixjms75lpw5" />

          <div className="relative bg-gradient-to-br from-amber-950/60 via-stone-950/80 to-black border-2 sm:border-4 border-amber-600/60 p-5 sm:p-8 md:p-10 shadow-[0_0_16px_rgba(217,119,6,0.26)] sm:shadow-[0_0_60px_rgba(217,119,6,0.5)]" data-id="element-1887" data-mp="3k7npfw2lw9d">
            <div className="absolute top-0 left-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-1888" data-mp="25h837ynp5wp4">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 to-transparent" data-id="element-1889" data-mp="25f55esgayz9u" />
              <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-amber-500 to-transparent" data-id="element-1890" data-mp="1wga1jn0qe19p" />
              <div className="absolute top-2 left-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" data-id="element-1891" data-mp="2t72gghbxhn9w" />
            </div>
            <div className="absolute top-0 right-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-1892" data-mp="2o77mg4wuwhkm">
              <div className="absolute top-0 right-0 w-full h-1 bg-gradient-to-l from-amber-500 to-transparent" data-id="element-1893" data-mp="2k5m8eg8l5x8u" />
              <div className="absolute top-0 right-0 w-1 h-full bg-gradient-to-b from-amber-500 to-transparent" data-id="element-1894" data-mp="2f7kndprlnnuq" />
              <div className="absolute top-2 right-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '0.5s'
            }} data-id="element-1895" data-mp="18rqtn8llfqi5" />
            </div>
            <div className="absolute bottom-0 left-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-1896" data-mp="3fcv5f0j3x689">
              <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 to-transparent" data-id="element-1897" data-mp="3kekg2f2f3hvt" />
              <div className="absolute bottom-0 left-0 w-1 h-full bg-gradient-to-t from-amber-500 to-transparent" data-id="element-1898" data-mp="3odjjfv8i36l5" />
              <div className="absolute bottom-2 left-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '1s'
            }} data-id="element-1899" data-mp="3t8775rvojwyo" />
            </div>
            <div className="absolute bottom-0 right-0 w-8 sm:w-12 h-8 sm:h-12" data-id="element-1900" data-mp="bxzf9ljxvv3s">
              <div className="absolute bottom-0 right-0 w-full h-1 bg-gradient-to-l from-amber-500 to-transparent" data-id="element-1901" data-mp="fzkngtlj3l7n" />
              <div className="absolute bottom-0 right-0 w-1 h-full bg-gradient-to-t from-amber-500 to-transparent" data-id="element-1902" data-mp="2dqdw0haqytim" />
              <div className="absolute bottom-2 right-2 w-3 h-3 bg-amber-500 rotate-45 animate-pulse" style={{
              animationDelay: '1.5s'
            }} data-id="element-1903" data-mp="2hrz47pcc6jmh" />
            </div>

            <div className="flex justify-center mb-4 sm:mb-6" data-id="element-1904" data-mp="1ihs5pu3yk2ad">
              <div className="relative" data-id="element-1905" data-mp="1wdvxzhv9u0k7">
                <div className="absolute inset-0 bg-amber-500/40 blur-xl animate-pulse-slow" data-id="element-1906" data-mp="1wcuh2wrkqjuk" />
                <AlertOctagon className="relative w-10 h-10 sm:w-12 sm:h-12 text-amber-400 drop-shadow-[0_0_15px_rgba(251,191,36,0.8)]" data-id="element-1907" data-mp="1reay958a1o6f" />
              </div>
            </div>

            <div className="text-center mb-4" data-id="element-1908" data-mp="yt9n5vdgjn4n">
              <span className="inline-block px-3 sm:px-6 py-2 bg-amber-600/30 border-2 border-amber-500/50 text-amber-400 font-bold tracking-normal sm:tracking-[0.2em] uppercase text-xs sm:text-lg md:text-xl" style={{
              textShadow: '0 0 20px rgba(251, 191, 36, 0.6)'
            }} data-id="element-1909" data-mp="1dg2vuhsh1unv">
                Classic Misinformation Spread In The Peptide World #6
              </span>
            </div>

            <h4 className="text-2xl sm:text-3xl md:text-5xl font-serif text-center text-amber-100 leading-tight font-bold" style={{
            fontFamily: 'Cinzel, serif',
            textShadow: '0 0 40px rgba(217, 119, 6, 0.8), 0 0 60px rgba(217, 119, 6, 0.4)'
          }} data-id="element-1910" data-mp="2rm7kq6rdp5xy">
              The Bioregulator Blind Spot: Almost Nobody Knows They Exist
            </h4>
          </div>
        </div>

        {/* Content Box */}
        <div className="bg-stone-900/40 border border-stone-800 p-6 sm:p-8 md:p-10 rounded-sm relative overflow-hidden" data-id="element-1911" data-mp="3fd3hzjelstcl">
          <div className="absolute top-0 left-0 w-64 h-64 bg-amber-900/10 blur-3xl rounded-full -translate-y-1/2 -translate-x-1/2" data-id="element-1912" data-mp="36d6qzb4qried" />

          <div className="space-y-4 sm:space-y-6 text-base sm:text-lg text-stone-300 relative z-10" data-id="element-1913" data-mp="1pyoxjbambsmw">
            <p data-id="element-1914" data-mp="1uz2xs75z9yad">
              This is the most shocking oversight in the entire peptide
              ecosystem:
            </p>

            <p className="text-lg sm:text-xl text-stone-100 font-bold border-l-4 border-amber-600 pl-4 sm:pl-6 py-2 bg-gradient-to-r from-amber-950/30 to-transparent" data-id="element-1915" data-mp="h1k4cvx9t8l">
              Most people in the peptide world have never even heard of
              Khavinson's bioregulator peptides.
            </p>

            <p data-id="element-1916" data-mp="3ivkb3zftlmvv">
              They talk endlessly about BPC-157, TB-500, CJC-1295, ipamorelin,
              semaglutide... yet remain completely oblivious to the category of
              peptides that are some of the most powerful, safest, and
              biologically transformative compounds humans have ever discovered.
            </p>

            <div className="bg-stone-950/50 p-4 sm:p-6 border border-stone-800 rounded-sm my-6 sm:my-8" data-id="element-1917" data-mp="2zxgaxuhwuy67">
              <div className="flex items-center gap-3 mb-4" data-id="element-1918" data-mp="127gezoec19la">
                <Dna className="w-6 h-6 text-amber-500" data-id="element-1919" data-mp="124u9dub0545p" />
                <p className="text-stone-100 font-bold text-base sm:text-lg" data-id="element-1920" data-mp="y6wjep9eqe19">
                  Bioregulators are not "just another type of peptide."
                </p>
              </div>
              <p className="text-stone-300 pl-9 text-sm sm:text-base" data-id="element-1921" data-mp="2l19ieoi0uh7t">
                They operate differently. They target the genome itself. They
                influence tissue at the level of DNA transcription. They don't
                stimulate—they normalize. They don't push the body—they instruct
                it. They are an entirely different class of biological
                intelligence.
              </p>
            </div>

            <p data-id="element-1922" data-mp="225jgt2e03mug">And yet...</p>

            <p data-id="element-1923" data-mp="264irz4qbsfuc">The peptide mainstream has absolutely no idea they exist.</p>

            <p data-id="element-1924" data-mp="267d9ane1lkjj">
              Even the so-called experts (educators, influencers, doctors with
              massive followings) are teaching an incomplete universe of
              peptides. Their map is missing the most valuable territory.
            </p>

            {/* NEW: Doctor YouTube Example Image */}
            <div className="relative my-8" data-id="element-1925" data-mp="2y6gpav6eympg">
              <div className="absolute -inset-1 bg-gradient-to-r from-red-600/20 to-amber-600/20 rounded-lg blur" data-id="element-1926" data-mp="2y7hysv7s7152" />
              <div className="relative bg-stone-950 p-2 rounded-lg border border-red-600/30" data-id="element-1927" data-mp="2t9ghoftx1bw8">
                <img src="https://cdn.magicpatterns.com/uploads/piPwtgJdRX7h6R5ZWny4D1/image.png" alt="Doctor on YouTube ranking peptides" className="w-full rounded" data-id="element-1928" data-mp="370bkbadtmwrd" />
                <p className="text-sm sm:text-base text-stone-300 mt-3 px-2 leading-relaxed" data-id="element-1929" data-mp="3bydeorgp6ii5">
                  Ignoring the fact he spelled ipamorelin wrong, this is a
                  doctor on Youtube with a video that has over 100k views,
                  giving epitalon the LOWEST ranking possible. All because he
                  thinks there hasn't been enough legitimate research on it. But{' '}
                  <span className="font-bold text-stone-100" data-id="element-1930" data-mp="1rirwtgqgnodu">
                    epitalon has more studies proving its effectiveness in
                    humans than others he ranked higher
                  </span>
                  . It SHOULD be an A or even S-tier peptide - he ranked it F!
                </p>
              </div>
            </div>

            <p className="text-stone-100 font-bold mt-8" data-id="element-1931" data-mp="17o9uu146uyxr">But it goes deeper:</p>

            <p data-id="element-1932" data-mp="1cmblp87uw2js">
              Among the microscopic percentage of practitioners who do know
              about bioregulators, almost every single one of them only
              understands Version 1 bioregulator products.
            </p>

            <p className="text-amber-500 font-medium italic" data-id="element-1933" data-mp="12n2nu49ve3s5">
              The lowest-tier, least evolved, bare-minimum formulations.
            </p>

            <div className="space-y-4 my-6 sm:my-8 pl-4 border-l-2 border-stone-700 text-sm sm:text-base" data-id="element-1934" data-mp="tpjw6h1q0r7a">
              <div data-id="element-1935" data-mp="2j501flcixsrw">
                <p className="text-stone-100 font-bold" data-id="element-1936" data-mp="2j1m1skv8vxo5">
                  Version 1 = The bare minimum required to work
                </p>
                <p className="text-stone-400 text-xs sm:text-sm" data-id="element-1937" data-mp="ndoao67ivoht">
                  (This is what everyone talks about. It's entry-level.)
                </p>
              </div>

              <div data-id="element-1938" data-mp="edi12vey38nx">
                <p className="text-stone-100 font-bold" data-id="element-1939" data-mp="ee18hi6yyenp">
                  Version 2 = A dramatically more potent biological signal
                </p>
                <p className="text-stone-400 text-xs sm:text-sm" data-id="element-1940" data-mp="ida2mo5x8ejs">
                  (Rare, unknown, and exponentially more effective.)
                </p>
              </div>

              <div data-id="element-1941" data-mp="9f6oicx9mk20">
                <p className="text-stone-100 font-bold" data-id="element-1942" data-mp="9fpxh44xty3w">
                  Version 3 = So powerful they must be used with extreme caution
                </p>
                <p className="text-stone-400 text-xs sm:text-sm" data-id="element-1943" data-mp="3vt80swcwcqsn">
                  (Nearly nobody has access, understanding, or safe dosing
                  knowledge.)
                </p>
              </div>
            </div>

            <div className="flex gap-4 items-start bg-amber-950/30 p-4 sm:p-6 border border-amber-600/50 rounded-sm my-6 sm:my-8" data-id="element-1944" data-mp="3msrz9sfprtqf">
              <Zap className="w-6 h-6 text-amber-500 flex-shrink-0 mt-1" data-id="element-1945" data-mp="339cjb25qwiy3" />
              <div data-id="element-1946" data-mp="2ya9f1jxlagr6">
                <p className="text-stone-100 font-bold text-base sm:text-lg leading-relaxed" data-id="element-1947" data-mp="2yarl18a209ca">
                  Peptide Mastery 2.0 is the ONLY place where you will discover
                  about all three versions and how to apply them in-depth, at a
                  level beyond anything else in the world.
                </p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>

      {/* NEW SECTION: Classic Misinformation #7 */}
      <motion.div ref={ref10} initial={{
      opacity: 0,
      y: 20
    }} animate={inView10 ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.4
    }} className="relative z-10 max-w-4xl mx-auto mt-20 sm:mt-32" data-id="element-1948" data-mp="3vvnlgh902rx0">
        {/* Decorative Divider */}
        <div className="flex items-center justify-center gap-4 mb-8 sm:mb-12" data-id="element-1949" data-mp="2xi9o1gvz30so">
          <div className="w-16 sm:w-32 h-px bg-gradient-to-r from-transparent via-amber-600/50 to-amber-600/50" data-id="element-1950" data-mp="32jz1122r9oje" />
          <div className="w-2 h-2 bg-amber-600 rotate-45" data-id="element-1951" data-mp="36iy1a9djkx4i" />
          <div className="w-16 sm:w-32 h-px bg-gradient-to-l from-transparent via-amber-600/50 to-amber-600/50" data-id="element-1952" data-mp="3bcsqttftw6bi" />
        </div>

        {/* Headline with "problem" in red */}
        <h2 className="text-2xl sm:text-3xl md:text-5xl font-serif text-center mb-8 sm:mb-12 leading-tight" style={{
        fontFamily: 'Cinzel, serif'
      }} data-id="element-1953" data-mp="3l9fc2jc2gze2">
          <span className="block text-amber-500 font-bold mb-3" style={{
          textShadow: '0 0 40px rgba(217, 119, 6, 0.5)'
        }} data-id="element-1954" data-mp="3ub51jjme1o97">
            The{' '}
            <span className="relative inline-block" data-id="element-1955" data-mp="1zvu488g2pr1y">
              <span className="text-red-500" style={{
              textShadow: '0 0 50px rgba(239, 68, 68, 0.8), 0 0 80px rgba(220, 38, 38, 0.4)'
            }} data-id="element-1956" data-mp="1zyopu3atphwy">
                Problem
              </span>
              <span className="absolute -bottom-2 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-red-500 to-transparent opacity-60 blur-sm" data-id="element-1957" data-mp="1injg0scrdh0i" />
            </span>{' '}
            With All This:
          </span>
        </h2>

        {/* Body content */}
        <div className="space-y-6 text-lg md:text-xl leading-relaxed text-stone-300" data-id="element-1958" data-mp="26cm5gmdmwe5k">
          <p className="text-stone-100 font-semibold text-lg sm:text-xl border-l-4 border-amber-600 pl-4 sm:pl-6 py-2 bg-gradient-to-r from-amber-950/20 to-transparent" data-id="element-1959" data-mp="22ar6hoj6ecuy">
            The information you're relying on — even from "qualified experts" —
            is incomplete, oversimplified, or flat-out wrong.
          </p>

          <p className="text-stone-100" data-id="element-1960" data-mp="lvzgfi9i5hot">
            And this isn't just about missing optimal results.
          </p>

          <p className="font-bold text-stone-100" data-id="element-1961" data-mp="29s5hrtuor6rn">
            This is about making mistakes that compound over months and years.
          </p>

          <div className="space-y-4 pl-4 sm:pl-6 border-l-2 border-red-600/50 text-base sm:text-lg" data-id="element-1962" data-mp="20tafgsurigtm">
            <p data-id="element-1963" data-mp="24uccr454cisy">
              <span className="text-red-400 font-bold" data-id="element-1964" data-mp="24tuczxj8zmga">
                Mistakes that silently damage your biology
              </span>{' '}
              while you think you're optimizing it.
            </p>

            <p data-id="element-1965" data-mp="2xi8amc6fcgrb">
              <span className="text-red-400 font-bold" data-id="element-1966" data-mp="2xiri0yyg7mr3">
                Mistakes that waste thousands of dollars
              </span>{' '}
              on ineffective products and protocols.
            </p>

            <p data-id="element-1967" data-mp="2ogrzg27scam1">
              <span className="text-red-400 font-bold" data-id="element-1968" data-mp="2okftr3l2111t">
                Mistakes that cost you the irreplaceable resource of time
              </span>{' '}
              as your biology continues to decay.
            </p>
          </div>

          <p className="text-xl sm:text-2xl font-bold text-stone-100 mt-6 sm:mt-8" data-id="element-1969" data-mp="14lw58d12lwj6">
            Or worse...
          </p>

          <p className="text-red-400 font-bold" data-id="element-1970" data-mp="10k298i1tlgpc">
            Mistakes that damage the trust of the people who rely on YOU for
            guidance.
          </p>

          {/* Divider */}
          <div className="flex items-center justify-center gap-4 py-8 sm:py-12 my-8 sm:my-12" data-id="element-1971" data-mp="19mjxf211cjez">
            <div className="w-16 sm:w-32 h-px bg-gradient-to-r from-transparent via-amber-600/50 to-amber-600/50" data-id="element-1972" data-mp="lwzdogx25i4n" />
            <div className="w-2 h-2 bg-amber-600 rotate-45" data-id="element-1973" data-mp="gy5vwcaqn4yo" />
            <div className="w-16 sm:w-32 h-px bg-gradient-to-l from-transparent via-amber-600/50 to-amber-600/50" data-id="element-1974" data-mp="vm95rwrwj0sr" />
          </div>

          {/* NEW SECTION: But You Can't Just Solve This With "Better Information" */}
          <h3 className="text-2xl sm:text-3xl md:text-4xl font-serif font-bold text-center text-stone-100 mb-6 sm:mb-8" style={{
          fontFamily: 'Cinzel, serif',
          textShadow: '0 0 20px rgba(217, 119, 6, 0.2)'
        }} data-id="element-1975" data-mp="34enj78qtr4j">
            But You Can't Just Solve This With{' '}
            <span className="text-amber-500" style={{
            textShadow: '0 0 30px rgba(217, 119, 6, 0.5)'
          }} data-id="element-1976" data-mp="235ux0bnbc0ds">
              "Better Information"
            </span>
          </h3>

          <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-1977" data-mp="1faa44kvlueeu">
            Here's what most people don't understand:
          </p>

          <p className="text-stone-100" data-id="element-1978" data-mp="1k9daq9r8gsox">
            You can't solve this problem by just "finding better sources."
          </p>

          <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-1979" data-mp="1ocrsb4utlh4h">
            Because even the BEST sources out there are still operating with an
            incomplete paradigm.
          </p>

          <div className="space-y-4 pl-4 sm:pl-6 border-l-2 border-amber-600/30 text-base sm:text-lg" data-id="element-1980" data-mp="2zry9a7vm0nk6">
            <p data-id="element-1981" data-mp="3esly72ws7wa5">They're teaching you a FRACTION of what's possible.</p>
            <p data-id="element-1982" data-mp="3eru1tpvd1uit">They're giving you a MAP that's missing half the territory.</p>
          </div>

          <p className="text-stone-100" data-id="element-1983" data-mp="39u29wvupu8em">
            And no amount of "doing your own research" is going to fix that...
          </p>

          <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-1984" data-mp="311733xplo4mq">
            Unless you're willing to:
          </p>

          <div className="space-y-3 pl-4 sm:pl-6 border-l-2 border-stone-700 text-base sm:text-lg" data-id="element-1985" data-mp="2w2nh5xb0asud">
            <p className="flex items-start gap-3" data-id="element-1986" data-mp="2r2hruns7lifg">
              <span className="text-amber-500 flex-shrink-0" data-id="element-1987" data-mp="2r5424v6hic1d">→</span>
              <span data-id="element-1988" data-mp="2m4ps57lbos0p">Learn Russian</span>
            </p>
            <p className="flex items-start gap-3" data-id="element-1989" data-mp="2i2cpis1vha85">
              <span className="text-amber-500 flex-shrink-0" data-id="element-1990" data-mp="2i3xhqb0psh2u">→</span>
              <span data-id="element-1991" data-mp="kcuvnz7n0u32">
                Track down obscure military and academic journals from the
                Soviet era
              </span>
            </p>
            <p className="flex items-start gap-3" data-id="element-1992" data-mp="g959fgefqol7">
              <span className="text-amber-500 flex-shrink-0" data-id="element-1993" data-mp="zkso54zp5s77">→</span>
              <span data-id="element-1994" data-mp="13l36zi8l8d3h">
                Translate hundreds of studies that have never been brought to
                the West
              </span>
            </p>
            <p className="flex items-start gap-3" data-id="element-1995" data-mp="ptobibxhujfj">
              <span className="text-amber-500 flex-shrink-0" data-id="element-1996" data-mp="ushm9wlebwc0">→</span>
              <span data-id="element-1997" data-mp="uqohkmucfm6n">
                Spend years understanding peptide mechanisms at the molecular
                level
              </span>
            </p>
            <p className="flex items-start gap-3" data-id="element-1998" data-mp="kvmqhlgica1f">
              <span className="text-amber-500 flex-shrink-0" data-id="element-1999" data-mp="6v2b6z9swwco">→</span>
              <span data-id="element-2000" data-mp="6wwxoi0q0wiv">
                Work with enough real human cases to know what actually works
                vs. what just sounds good in theory
              </span>
            </p>
            <p className="flex items-start gap-3" data-id="element-2001" data-mp="219mo2prvrnli">
              <span className="text-amber-500 flex-shrink-0" data-id="element-2002" data-mp="267wobesgpedz">→</span>
              <span data-id="element-2003" data-mp="2663l69h25caq">
                Develop your own diagnostic frameworks for identifying root
                causes
              </span>
            </p>
            <p className="flex items-start gap-3" data-id="element-2004" data-mp="2be32rftmiynq">
              <span className="text-amber-500 flex-shrink-0" data-id="element-2005" data-mp="2bb77y0d2oq3i">→</span>
              <span data-id="element-2006" data-mp="2p5zuvjval8k4">
                Create your own protocol design methodology based on synergistic
                effects
              </span>
            </p>
          </div>

          <p className="text-lg sm:text-xl font-bold text-stone-100 mt-6 sm:mt-8" data-id="element-2007" data-mp="2z1jizk3m72yb">
            In other words...
          </p>

          <p className="text-xl sm:text-2xl font-bold text-amber-500" data-id="element-2008" data-mp="2u39s3loxaoii">
            Unless you're willing to do what Brenden Henry has done.
          </p>

          <div className="space-y-3 pl-4 sm:pl-6 border-l-2 border-amber-600/30 text-base sm:text-lg" data-id="element-2009" data-mp="341fppr3p58hk">
            <p data-id="element-2010" data-mp="1dohzb7nv7f8o">Which took him years of effort.</p>
            <p data-id="element-2011" data-mp="1drcjcy2yuy1k">And thousands of hours of obsessive research.</p>
            <p data-id="element-2012" data-mp="19ozmkz676agx">And real-world application with over 1,500 participants.</p>
            <p data-id="element-2013" data-mp="im4vif29wruu">
              And private transformation work with clients paying $15K−$120K.
            </p>
          </div>

          <p className="text-lg sm:text-xl font-bold text-stone-100 mt-6 sm:mt-8" data-id="element-2014" data-mp="do3c1t0xqqiu">
            So here's the reality:
          </p>

          <p className="text-stone-100" data-id="element-2015" data-mp="8tpdxiuw25ah">You have two options.</p>

          <div className="bg-gradient-to-br from-stone-950/60 to-black border-2 border-stone-700 p-6 sm:p-8 my-6 sm:my-8" data-id="element-2016" data-mp="3w7b8a7gsmax">
            <p className="text-lg sm:text-xl font-bold text-stone-100 mb-4" data-id="element-2017" data-mp="3vyoq5boumouo">
              Option 1:
            </p>
            <p className="text-stone-300 text-base sm:text-lg" data-id="element-2018" data-mp="3m2lqcchgz2aw">
              Spend the next 10+ years trying to figure this out on your own.
            </p>
            <p className="text-stone-400 text-sm mt-2 italic" data-id="element-2019" data-mp="3h5216hj8h546">
              (And hope you don't make too many costly mistakes along the way.)
            </p>
          </div>

          <div className="bg-gradient-to-br from-amber-950/30 to-black border-2 border-amber-600/50 p-6 sm:p-8 my-6 sm:my-8" data-id="element-2020" data-mp="1fbw2hdrr47hj">
            <p className="text-lg sm:text-xl font-bold text-amber-400 mb-4" data-id="element-2021" data-mp="1nsmvuitjurta">
              Option 2:
            </p>
            <p className="text-stone-100 text-base sm:text-lg" data-id="element-2022" data-mp="1rsnbg6sdx91x">
              Get direct access to the people who've already done the work.
            </p>
            <p className="text-stone-100 text-base sm:text-lg" data-id="element-2023" data-mp="21kt4ljudhwip">
              Who've already made the paradigm shift.
            </p>
            <p className="text-stone-100 text-base sm:text-lg" data-id="element-2024" data-mp="14w3hnf3w2dpv">
              Who already KNOW what's possible.
            </p>
            <p className="text-stone-100 text-base sm:text-lg" data-id="element-2025" data-mp="1duyp0uio5tur">
              And who are willing to share it with you.
            </p>
          </div>

          <div className="bg-gradient-to-br from-amber-950/30 to-black border-2 border-amber-600 p-6 sm:p-8 md:p-10 mt-6 sm:mt-8 relative" data-id="element-2026" data-mp="1iuuteuva3nau">
            <div className="absolute top-0 left-0 w-6 sm:w-8 h-6 sm:h-8 border-l-2 border-t-2 border-amber-600" data-id="element-2027" data-mp="2pci2dfpyrd71" />
            <div className="absolute top-0 right-0 w-6 sm:w-8 h-6 sm:h-8 border-r-2 border-t-2 border-amber-600" data-id="element-2028" data-mp="24kt6p07zrp0j" />
            <div className="absolute bottom-0 left-0 w-6 sm:w-8 h-6 sm:h-8 border-l-2 border-b-2 border-amber-600" data-id="element-2029" data-mp="1zmi0r0kthynl" />
            <div className="absolute bottom-0 right-0 w-6 sm:w-8 h-6 sm:h-8 border-r-2 border-b-2 border-amber-600" data-id="element-2030" data-mp="2ei7nx21qohtw" />

            <p className="text-xl sm:text-2xl md:text-3xl text-center font-bold text-amber-500 leading-relaxed" style={{
            textShadow: '0 0 30px rgba(217, 119, 6, 0.4)'
          }} data-id="element-2031" data-mp="29kpbh1oijkh5">
              That's what PSI PRO — The Private Research Order is.
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}